import { supabase } from "./supabaseClient"
import {
  getOperationalDate,
  formatDate
} from './utils/dateUtils'
import {
  saveUserSettings,
  fetchUserPreferences,
  fetchPauseMode
} from './services/user/userPreferencesService'
import {
    fetchPauseModePreference
} from './services/user/userPreferencesService'
import { logTaskEvent } from './utils/taskEventUtils'
import { useEffect, useState, useRef } from 'react'
import { signIn } from './services/auth/authService'
import { useAuth } from './services/auth/authProvider';
import { useUniversalFilter } from './context/UniversalFilterContext';
import './App.css'
import logo from './logo.png'
import { ReactComponent as EditIcon } from './assets/edit.svg'
import { ReactComponent as TrashIcon } from './assets/delete.svg'
import { ReactComponent as SkipIcon } from './assets/skip.svg'
import editIcon from './assets/edit.svg'
import skipIcon from './assets/skip.svg'
import deleteIcon from './assets/delete.svg'
import StatusBadge from './components/StatusBadge'
import {
  runRecurringEngine,
  updateTemplateAfterCompletion
} from './recurrenceEngine'
import RecurringPage
  from './pages/RecurringPage'
import PlanningPage from './pages/PlanningPage'
import ShoppingPage from './features/shopping/ShoppingPage';
import PersonalOrganizationPage
  from './pages/PersonalOrganizationPage';
import TaskForm from './components/forms/TaskForm';
import EditButton from "./components/buttons/EditButton";
import SkipButton from "./components/buttons/SkipButton";
import DeleteButton from "./components/buttons/DeleteButton";
import QuickCapturePage from "./pages/QuickCapturePage";
import ClarifyPage from "./pages/ClarifyPage";
import ProjectForm from './components/forms/ProjectForm'
import { calculateReviewStatus } from './utils/reviewStatusUtils'
import { ReviewStatusBadge } from './utils/reviewStatusUtils'

import ProjectPage from './pages/ProjectPage'

import BugReportPage from "./features/bugs/BugReportPage";

import { hydrateTasks } from './transformers/hydrateTask'
import { hydrateRecurringTasks} from './transformers/hydrateRecurringTask'

import {
  saveProjectService,
  saveProjectTaskService,
  saveProjectRecurringService,
  deleteProjectService,
  fetchProjectsService,
  archiveProjectService
} from './services/projects/projectService'

function App() {

  const {
    authenticatedUser,
    currentUser,
    loading,
    setCurrentUser,
    refreshCurrentUser
  } = useAuth()

  const recurringEngineRunning = useRef(false)

  const recurrenceInitializedForUser = useRef(null)

  const { activeUniversalFilter, toggleUniversalFilter } = useUniversalFilter();

  const [universalFilters, setUniversalFilters] = useState([]);

  const operationalToday =
    getOperationalDate(
      currentUser?.timezone || 'UTC',
      currentUser?.operational_day_start || 4
    )
  const todayString = formatDate(operationalToday)

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const [tasks, setTasks] = useState([])
  const [allTasks, setAllTasks] = useState([])
  const [newTask, setNewTask] = useState('')
  const [editingTaskId, setEditingTaskId] = useState(null)
  const [pendingInboxId, setPendingInboxId] = useState(null)
  const [taskDate, setTaskDate] = useState('')
  const [contextId, setContextId] = useState('')
  const [focusAreaId, setFocusAreaId] = useState('')
  const [locationId, setLocationId] = useState('')
  const [filter, setFilter] = useState('all')
  const [taskType, setTaskType] = useState(1)
  const [taskTypes, setTaskTypes] = useState([])
  const [priorityLevels, setPriorityLevels] = useState([])
  const [priorityId, setPriorityId] = useState('')
  const [statusLevels, setStatusLevels] = useState([])
  const [statusId, setStatusId] = useState(1)
  const [statusFilter, setStatusFilter] = useState('active')

  const [timeOfDayLevels, setTimeOfDayLevels] = useState([])
  const [impactLevels, setImpactLevels] = useState([])
  const [capacityLevels, setCapacityLevels] = useState([])
  const [dayTypeLevels, setDayTypeLevels] = useState([])

  const [timeOfDayId, setTimeOfDayId] = useState('')
  const [impactId, setImpactId] = useState('')
  const [capacityId, setCapacityId] = useState('')
  const [dayTypeId, setDayTypeId] = useState('')

  const [pausedMode, setPausedMode] = useState(false)

   const [dueDate, setDueDate] =
    useState(
      formatDate(operationalToday)
    )

  const [focusCount, setFocusCount] = useState(3)
  const [focusType, setFocusType] = useState('all')
  const [taskTimes, setTaskTimes] = useState([])
  const [taskTime, setTaskTime] = useState(null)
  const [newRecurringTask, setNewRecurringTask] = useState('')
  const [recurrenceType, setRecurrenceType] = useState(1)
  const [recurrenceTypes, setRecurrenceTypes] = useState([])
  const [recurringDayOfWeek, setRecurringDayOfWeek] = useState('')
  const [recurringDayOfMonth, setRecurringDayOfMonth] = useState('')
  const [recurringMonthOfYear, setRecurringMonthOfYear] = useState('')
  const [recurringDaysOfWeek, setRecurringDaysOfWeek] = useState([])
  const [recurringStatusId, setRecurringStatusId] = useState(1)
  const [recurrenceAnchorType, setRecurrenceAnchorType] = useState('calendar');
  const [persistenceType, setPersistenceType] = useState('keep_until_done');
  
  const [recurringMonthlyRuleType, setRecurringMonthlyRuleType] =
    useState('day_of_month')

  const [recurringMonthlyWeekday, setRecurringMonthlyWeekday] =
    useState('')

  const [recurringMonthlyWeekNumbers, setRecurringMonthlyWeekNumbers] =
    useState([])

   const [recurrenceStartDate, setRecurrenceStartDate] =
    useState(formatDate(operationalToday));

  const [recurrenceEndDate, setRecurrenceEndDate] = useState('');
  const [lastReviewedAt, setLastReviewedAt] = useState('');

  const [recurringSearch, setRecurringSearch] = useState('')
  const [recurringFocusFilter, setRecurringFocusFilter] = useState('all')
  const [recurringLocationFilter, setRecurringLocationFilter] = useState('all')
  const [recurringSortBy, setRecurringSortBy] = useState('az')

  const [toast, setToast] = useState('')
  const [smartView, setSmartView] = useState('all')
  const [notes, setNotes] = useState('')
  const [recurringNotes, setRecurringNotes] = useState('')
  const [page, setPage] = useState(() => {
  const params = new URLSearchParams(window.location.search)
    return params.get('page') || 'tasks'
  })
  const [projects, setProjects] = useState([])
  const [locations, setLocations] = useState([])
  const [contexts, setContexts] = useState([])
  const [focusAreas, setFocusAreas] = useState([])
  const [projectId, setProjectId] = useState('')
  const [recurringProjectId, setRecurringProjectId] = useState('')
  const [projectStatusId, setProjectStatusId] = useState(1)
  const [projectFocusAreaId, setProjectFocusAreaId] = useState('')

  const [projectSearch, setProjectSearch] = useState('')
  const [projectFilterFocusArea, setProjectFilterFocusArea] = useState('')
  const [projectFilterStatus, setProjectFilterStatus] = useState('')
  const [showArchived, setShowArchived] = useState(false)
  const [taskFilterProject, setTaskFilterProject] = useState('')

  const [focusBlockType, setFocusBlockType] = useState('project')
  const [focusBlockValue, setFocusBlockValue] = useState('')
  const [focusTaskTime, setFocusTaskTime] = useState('')
  const [recurringPriorityId, setRecurringPriorityId] = useState('')
  const [recurringTaskTime, setRecurringTaskTime] = useState('')
  const [recurringContextId, setRecurringContextId] = useState('')
  const [recurringFocusAreaId, setRecurringFocusAreaId] = useState('')
  const [recurringLocationId, setRecurringLocationId] = useState('')
  const [recurringTimeOfDayId, setRecurringTimeOfDayId] = useState('')
  const [recurringImpactId, setRecurringImpactId] = useState('')
  const [recurringCapacityId, setRecurringCapacityId] = useState('')
  const [recurringDayTypeId, setRecurringDayTypeId] = useState('')
  const [recurringIsActive, setRecurringIsActive] = useState(true)
  const [recurringIsPausable, setRecurringIsPausable] = useState(true)
  const [recurringTasksList, setRecurringTasksList] = useState([])
  const [intervalDays, setIntervalDays] = useState('')
  const [recurringIntervalValue, setRecurringIntervalValue] = useState('')
  const [recurringIntervalUnit, setRecurringIntervalUnit] = useState('days')

  const [editingRecurringId, setEditingRecurringId] = useState(null)
  const [seasons, setSeasons] = useState([])
  const [recurringSeasonId, setRecurringSeasonId] = useState('')
  const [seasonalFrequency, setSeasonalFrequency] = useState('')
  const [seasonName, setSeasonName] = useState('')
  const [seasonNotes, setSeasonNotes] = useState('')
  const [seasonStartMonth, setSeasonStartMonth] = useState('')
  const [seasonStartDay, setSeasonStartDay] = useState('')
  const [seasonEndMonth, setSeasonEndMonth] = useState('')
  const [seasonEndDay, setSeasonEndDay] = useState('')
  const [seasonIsActive, setSeasonIsActive] = useState(true)
  const [editingSeasonId, setEditingSeasonId] = useState(null)
  const [selectedSeasonId, setSelectedSeasonId] = useState(null)
  const [selectedSeason, setSelectedSeason] = useState(null)
  const [seasonTaskName, setSeasonTaskName] = useState('')
  const [editingSeasonTaskId, setEditingSeasonTaskId] = useState(null)

  const [seasonTaskNotes, setSeasonTaskNotes] = useState('')
  const [seasonTaskProjectId, setSeasonTaskProjectId] = useState('')
  const [seasonTaskPriorityId, setSeasonTaskPriorityId] = useState('')
  const [seasonTaskTime, setSeasonTaskTime] = useState('')
  const [seasonTaskContextId, setSeasonTaskContextId] = useState('')
  const [seasonTaskFocusAreaId, setSeasonTaskFocusAreaId] = useState('')
  const [seasonTaskLocationId, setSeasonTaskLocationId] = useState('')

  const [seasonTaskIsActive, setSeasonTaskIsActive] = useState(true)
  const [seasonTaskIsPausable, setSeasonTaskIsPausable] = useState(true)
  const [seasonalFrequencyLocal, setSeasonalFrequencyLocal] = useState('once')
  
  const [seasonTaskRecurrenceType, setSeasonTaskRecurrenceType] = useState('once')
  const [seasonTaskIntervalValue, setSeasonTaskIntervalValue] = useState(1)
  const [seasonTaskDaysOfWeek, setSeasonTaskDaysOfWeek] = useState([])
  const [seasonTaskDayOfMonth, setSeasonTaskDayOfMonth] = useState('')
  const [seasonTaskMonthlyRuleType, setSeasonTaskMonthlyRuleType] = useState('day_of_month')
  const [seasonTaskMonthlyWeekday, setSeasonTaskMonthlyWeekday] = useState('')
  const [seasonTaskMonthlyWeekNumbers, setSeasonTaskMonthlyWeekNumbers] = useState([])
  const [seasonTaskMonthOfYear, setSeasonTaskMonthOfYear] = useState('')

  const [profiles, setProfiles] = useState([])
  
  const [preferences, setPreferences] = useState(null)
  const [weeklySchedule, setWeeklySchedule] = useState([])
  const [timezone, setTimezone] = useState(
    currentUser?.timezone || 'America/Denver'
  )

  const [
    operationalDayStart,
    setOperationalDayStart
  ] = useState(4)

  const [adminStats, setAdminStats] = useState({})
  const [founderId, setFounderId] = useState(null)

  const [defaultFocusAreaId, setDefaultFocusAreaId] = useState('')
  const [defaultDailyFlowId, setDefaultDailyFlowId] = useState('')
  const [defaultDayTypeId, setDefaultDayTypeId] = useState('')

  const [signupFirst, setSignupFirst] = useState('')
  const [signupMiddle, setSignupMiddle] = useState('')
  const [signupLast, setSignupLast] = useState('')
  const [signupDisplay, setSignupDisplay] = useState('')
  const [signupEmail, setSignupEmail] = useState('')
  const [signupPassword, setSignupPassword] = useState('')
  const [signupPlan, setSignupPlan] = useState('free')

  const [locationTemplates, setLocationTemplates] = useState([])
  const [contextTemplates, setContextTemplates] = useState([])
  const [focusTemplates, setFocusTemplates] = useState([])
  const [recurringTemplates, setRecurringTemplates] = useState([])
  const [selectedRecurring, setSelectedRecurring] = useState([])

  const [selectedLocations, setSelectedLocations] = useState([])
  const [selectedContexts, setSelectedContexts] = useState([])
  const [selectedFocus, setSelectedFocus] = useState([])
  
  const [customLocation, setCustomLocation] = useState('')
  const [customContext, setCustomContext] = useState('')
  const [customFocus, setCustomFocus] = useState('')

  const [openProjectId, setOpenProjectId] = useState(null)
  const [newProjectTask, setNewProjectTask] = useState('')
  const [newProjectRecurring, setNewProjectRecurring] = useState('')

  const [selectedProject, setSelectedProject] = useState(null)
  const [editingProjectId, setEditingProjectId] = useState(null)

  const [projectName, setProjectName] = useState('')
  const [projectNotes, setProjectNotes] = useState('')

  const [projectTaskName, setProjectTaskName] = useState('')
  const [projectTaskNotes, setProjectTaskNotes] = useState('')

  const [projectRecurringName, setProjectRecurringName] = useState('')
  const [projectRecurringNotes, setProjectRecurringNotes] = useState('')
  const [projectRecurringFrequency, setProjectRecurringFrequency] = useState('once')

  const [searchText, setSearchText] = useState('')
  const [focusFilter, setFocusFilter] = useState('all')
  const [sortBy, setSortBy] = useState('az')

  const TIMEZONE_OPTIONS = [
    { value: 'America/New_York', label: 'Eastern Time (ET)' },
    { value: 'America/Chicago', label: 'Central Time (CT)' },
    { value: 'America/Denver', label: 'Mountain Time (MT)' },
    { value: 'America/Los_Angeles', label: 'Pacific Time (PT)' },
    { value: 'UTC', label: 'UTC' }
  ]

  const [openLocationGroups, setOpenLocationGroups] = useState({
  Home: true,
  Work: false,
  Outdoor: false,
  Family: false,
  Lifestyle: false,
  Property: false,
  Mobile: false
})

const addCustomContext = () => {
  const value = customContext.trim()
  if (!value) return

  if (selectedContexts.includes(value)) {
    setCustomContext('')
    return
  }

  setSelectedContexts([...selectedContexts, value])
  setCustomContext('')
}

const [loginEmail, setLoginEmail] = useState('')
const [loginPassword, setLoginPassword] = useState('')

async function handleLogin(e) {

  if (e) e.preventDefault()

  const { error } = await signIn(
    loginEmail,
    loginPassword
  )

  if (error) {
    showToast(error.message)
    return
  }

  // AuthProvider will receive the SIGNED_IN event.
  // It will load the profile.
  // It will set currentUser.
  // App will automatically leave the login screen.

}

const addCustomFocus = () => {
  const value = customFocus.trim()
  if (!value) return
  if (selectedFocus.includes(value)) {
    setCustomFocus('')
    return
  }

  setSelectedFocus([...selectedFocus, value])
  setCustomFocus('')
}





useEffect(() => {
  async function loadUniversalFilters() {
    const { data, error } = await supabase
      .from('universal_filters')
      .select('*')
      .eq('is_enabled', true)
      .order('button_position', { ascending: true });

    if (error) {
      console.error('Error loading universal filters:', error);
      return;
    }

    setUniversalFilters(data || []);
  }

  loadUniversalFilters();
}, []);

  useEffect(() => {
  // Wait until preferences and lookup tables are all loaded
  if (!preferences) return
  if (focusAreas.length === 0) return
  if (timeOfDayLevels.length === 0) return
  if (dayTypeLevels.length === 0) return

  const focusArea =
    preferences.default_focus_area_id?.toString() || ''

  const dailyFlow =
    preferences.default_daily_flow_id?.toString() || ''

  const dayType =
    preferences.default_day_type_id?.toString() || ''

  // Apply to Task form
  setFocusAreaId(focusArea)
  setTimeOfDayId(dailyFlow)
  setDayTypeId(dayType)

  // Apply to Recurring form
  setRecurringFocusAreaId(focusArea)
  setRecurringTimeOfDayId(dailyFlow)
  setRecurringDayTypeId(dayType)
}, [
  preferences,
  focusAreas,
  timeOfDayLevels,
  dayTypeLevels
])


  useEffect(() => {
  if (page === 'onboarding') {
    loadOnboardingTemplates()
    loadRecurringTemplates()
  }
}, [page])

useEffect(() => {
  if (!currentUser) return

  setTimezone(
    currentUser.timezone ||
    'America/Denver'
  )

  setOperationalDayStart(
    currentUser.operational_day_start || 4
  )

}, [currentUser])


 async function loadUserData() {
  console.log('LOAD USER DATA START')

  const userId = currentUser?.id

  if (!userId) {
    console.warn('LOAD USER DATA: no current user')
    return
  }

  // Load user-owned lookup data first.
  // These populate the dropdowns used throughout the app.
  await Promise.all([
    fetchProjects(userId),
    fetchLocations(userId),
    fetchSeasons(userId),
    fetchContexts(userId),
    fetchFocusAreas(userId)
  ])

  console.log('USER LOOKUPS LOADED:', userId)

  // Load recurring templates
  const recurringTemplates = await fetchAllRecurringTasks()

  // Load ALL existing tasks before running the engine
  const existingTasks = await fetchAllTasks()

  // Run the recurrence engine using the snapshot of existing tasks
await runRecurringTasksNow(
  recurringTemplates,
  existingTasks
)

console.log('RECURRENCE ENGINE COMPLETE')

// Refresh recurring templates for the UI
await fetchRecurringTasks()

// Refresh task lists after the engine has finished
await fetchTasks()
await fetchAllTasks()

  console.log('LOAD USER DATA COMPLETE:', userId)
}

useEffect(() => {
  if (!currentUser?.id) return

  const userId = currentUser.id

  if (recurrenceInitializedForUser.current === userId) {
    return
  }

  recurrenceInitializedForUser.current = userId

  console.log(
    'USER HYDRATION START:',
    userId
  )

  loadUserData().catch(error => {
    console.error(
      'USER HYDRATION ERROR:',
      error
    )
  })

}, [currentUser?.id])


useEffect(() => {

  fetchTaskTypes()
  fetchTaskTimes()
  fetchPriorityLevels()
  fetchStatusLevels()
  fetchRecurrenceTypes()
  fetchTimeOfDayLevels()
  fetchImpactLevels()
  fetchCapacityLevels()
  fetchDayTypeLevels()

}, [])

useEffect(() => {

  if (!authenticatedUser) {
    return
  }

  restoreActiveProfile()

}, [authenticatedUser])

useEffect(() => {
  if (page === 'admin' && authenticatedUser?.is_admin) {
    loadAdminStats()
  }
}, [page, profiles, authenticatedUser])

useEffect(() => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  })
}, [page])

function showToast(message) {
  setToast(message)
  setTimeout(() => {
    setToast('')
  }, 2200)
}

function switchUser(user) {

  if (!user) {
    return
  }

  if (!authenticatedUser?.is_admin) {
    console.warn('Unauthorized user switch attempt')
    return
  }

  console.log(
    'SWITCHING ACTIVE BLUPRINT USER:',
    user.id,
    user.email
  )

  setCurrentUser(user)

  localStorage.setItem(
    'bluprintUserId',
    user.id
  )

  if (
    user.onboarding_complete === false ||
    user.onboarding_complete == null
  ) {
    setPage('onboarding')
  } else {
    setPage('tasks')
  }
}

function clearProjectForm() {
  setProjectName('')
  setProjectNotes('')
  setEditingProjectId(null)
  setProjectStatusId(1)
  setProjectFocusAreaId('')
}

function clearProjectDetailForms() {
  setProjectTaskName('')
  setProjectTaskNotes('')
  setProjectRecurringName('')
  setProjectRecurringNotes('')
  setProjectRecurringFrequency('once')
}

function getTasksForProject(projectId) {
  return tasks.filter(
    task => task.project_id === projectId
  )
}

function getRecurringForProject(projectId) {
  return recurringTasksList.filter(
    item => item.project_id === projectId
  )
}

function openProject(project) {
  setSelectedProject(project)
  setPage('projectDetail')
}

function startProjectFromInbox(item) {
  setPendingInboxId(item.id)

  setProjectName(item.name || '')
  setProjectNotes(item.notes || '')
  setProjectFocusAreaId('')
  setProjectStatusId('10')

  setEditingProjectId(null)
  setPage('projects')
}

function startRecurringFromInbox(item) {
  resetRecurringForm()

  setNewRecurringTask(item.name || '')
  setRecurringNotes(item.notes || '')

  const statusId =
    item.status_id === 10 || item.status_id === 1
      ? 1
      : item.status_id

  setRecurringStatusId(10)

  setPendingInboxId(item.id)

  setPage('recurring')
}

async function fetchProjects(userId = currentUser?.id) {
  if (!userId) {
    setProjects([])
    return []
  }

  const { data, error } = await supabase
    .from('projects')
    .select('*')
    .eq('user_id', userId)
    .order('name', { ascending: true })

  console.log('FETCH PROJECTS:', {
    userId,
    data,
    error
  })

  if (error) {
    console.error('Error fetching projects:', error)
    setProjects([])
    return []
  }

  setProjects(data || [])
  return data || []
}


async function fetchLocations(userId = currentUser?.id) {
  if (!userId) {
    setLocations([])
    return []
  }

  const { data, error } = await supabase
    .from('locations')
    .select('*')
    .eq('user_id', userId)
    .order('sort_order', { ascending: true })

  console.log('FETCH LOCATIONS:', {
    userId,
    data,
    error
  })

  if (error) {
    console.error('Error fetching locations:', error)
    setLocations([])
    return []
  }

  setLocations(data || [])
  return data || []
}


async function fetchContexts(userId = currentUser?.id) {
  if (!userId) {
    setContexts([])
    return []
  }

  const { data, error } = await supabase
    .from('context')
    .select('*')
    .eq('user_id', userId)
    .order('sort_order', { ascending: true })

  console.log('FETCH CONTEXTS:', {
    userId,
    data,
    error
  })

  if (error) {
    console.error('Error fetching contexts:', error)
    setContexts([])
    return []
  }

  setContexts(data || [])
  return data || []
}


async function fetchFocusAreas(userId = currentUser?.id) {
  if (!userId) {
    setFocusAreas([])
    return []
  }

  const { data, error } = await supabase
    .from('focus_area')
    .select('*')
    .eq('user_id', userId)
    .order('name', { ascending: true })

  console.log('FETCH FOCUS AREAS:', {
    userId,
    data,
    error
  })

  if (error) {
    console.error('Error fetching focus areas:', error)
    setFocusAreas([])
    return []
  }

  setFocusAreas(data || [])
  return data || []
}

function editProject(project) {
  console.log('EDIT PROJECT OBJECT:', project)

  setProjectName(project.name || '')
  setProjectNotes(project.notes || '')
  setEditingProjectId(project.id)
  setProjectStatusId(project.status_id || '')
  setProjectFocusAreaId(project.focus_area_id || '')
  setPage('projects')

  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

async function saveProject() {
  try {
    const finalProjectStatusId =
      pendingInboxId &&
      (Number(projectStatusId) === 10 || !projectStatusId)
        ? 1
        : projectStatusId || null

    const project = await saveProjectService({
      projectName,
      projectNotes,
      projectFocusAreaId,
      projectStatusId: finalProjectStatusId,
      currentUser,
      editingProjectId
    })

    if (pendingInboxId && project?.id) {
      const { error } = await supabase
        .from('inbox')
        .update({
          processed_at: new Date().toISOString(),
          converted_to_type: 'project',
          converted_to_id: project.id
        })
        .eq('id', pendingInboxId)

      if (error) {
        console.error('Error processing inbox item:', error)
        showToast('⚠️ Project saved, but inbox item was not updated')
        return
      }

      setPendingInboxId(null)
    }

    clearProjectForm()
    fetchProjects()

    showToast('✅ Project saved')
  } catch (error) {
    console.error('Error saving project:', error)
    showToast('❌ Could not save project')
  }
}

async function saveProjectTask() {
  await saveProjectTaskService({
    projectTaskName,
    projectTaskNotes,
    selectedProject,
    currentUser
  })

  setProjectTaskName('')
  setProjectTaskNotes('')
  fetchTasks()
}

async function saveProjectRecurring() {
  await saveProjectRecurringService({
    projectRecurringName,
    projectRecurringNotes,
    projectRecurringFrequency,
    selectedProject,
    recurringDaysOfWeek,
    currentUser
  })

  setProjectRecurringName('')
  setProjectRecurringNotes('')
  setRecurringDaysOfWeek([])
  fetchRecurringTasks()
}

async function deleteProject(projectId) {
  await deleteProjectService(projectId)

  clearProjectForm()
  fetchProjects()
}

function attemptDeleteProject(project) {

    const openCount =
        getTasksForProject(project.id)
            .filter(t => !t.is_completed)
            .length

    const recurringCount =
        getRecurringForProject(project.id)
            .length

    const doneCount =
        getTasksForProject(project.id)
            .filter(t => t.is_completed)
            .length

    if (
        openCount ||
        recurringCount ||
        doneCount
    ) {

        const archive =
            window.confirm(
`This project contains:

📋 Open Tasks: ${openCount}
🔁 Recurring: ${recurringCount}
✅ Completed: ${doneCount}

Projects with work cannot be deleted.

Press OK to Archive instead.
Press Cancel to keep the project.`
)

        if (archive) {
            archiveProject(project.id)
        }

        return
    }

    if (
        window.confirm(
            "Delete this empty project forever?"
        )
    ) {
        deleteProject(project.id)
    }
}

async function archiveProject(projectId) {

    await archiveProjectService(projectId)

    fetchProjects()
}

async function completeTask(task) {

  await updateTask(task.id, {
    is_completed: !task.is_completed
  })

  await fetchTasks()
}





async function loadAdminStats() {
  const stats = {}

  for (const profile of profiles) {
    const userId = profile.id

    const { count: taskCount } = await supabase
      .from('tasks')
      .select('*', { count: 'exact', head: true })
      .eq('user_id', userId)

    const { count: recurringCount } = await supabase
      .from('recurring_tasks')
      .select('*', { count: 'exact', head: true })
      .eq('user_id', userId)

    const { count: seasonCount } = await supabase
      .from('seasons')
      .select('*', { count: 'exact', head: true })
      .eq('user_id', userId)

    const { count: projectCount } = await supabase
      .from('projects')
      .select('*', { count: 'exact', head: true })
      .eq('user_id', userId)

    stats[userId] = {
      taskCount: taskCount || 0,
      recurringCount: recurringCount || 0,
      seasonCount: seasonCount || 0,
      projectCount: projectCount || 0
    }
  }

  setAdminStats(stats)
}

async function resetUserTasks(profile) {
  const confirmed = window.confirm(
    `Delete all tasks for ${profile.display_name}?`
  )

  if (!confirmed) return

  await supabase
    .from('tasks')
    .delete()
    .eq('user_id', profile.id)

  loadAdminStats()
}

async function resetUserRecurring(profile) {
  const confirmed = window.confirm(
    `Delete all recurring tasks for ${profile.display_name}?`
  )

  if (!confirmed) return

  await supabase
    .from('recurring_tasks')
    .delete()
    .eq('user_id', profile.id)

  loadAdminStats()
}

async function toggleBeta(profile) {
  await supabase
    .from('profiles')
    .update({
      beta_tester: !profile.beta_tester
    })
    .eq('id', profile.id)

  fetchProfiles()
}

async function toggleActive(profile) {
  await supabase
    .from('profiles')
    .update({
      is_active: !profile.is_active
    })
    .eq('id', profile.id)

  fetchProfiles()
}

{/*
async function createSignupUser() {
  if (
    !signupFirst.trim() ||
    !signupLast.trim() ||
    !signupEmail.trim()
  ) {
    showToast('First name, last name, and email are required')
    return
  }

  const displayName =
    signupDisplay.trim() || signupFirst.trim()

  const { data: profilesData } = await supabase
    .from('profiles')
    .select('bluprint_id')

  const nextId =
    Math.max(
      0,
      ...profilesData.map(p => p.bluprint_id || 0)
    ) + 1

  const { data, error } = await supabase
  .from('profiles')
  .insert({
    first_name: signupFirst.trim(),
    middle_name: signupMiddle.trim(),
    last_name: signupLast.trim(),
    display_name: displayName,
    email: signupEmail.trim(),
    plan_type: signupPlan,
    is_active: true,
    onboarding_complete: false,
    beta_tester: false,
    is_admin: false,
    bluprint_id: nextId
  })
  .select()
  .single()

  if (error) {
    console.log(error)
    showToast('Signup failed')
    return
  }

  setSignupFirst('')
  setSignupMiddle('')
  setSignupLast('')
  setSignupDisplay('')
  setSignupEmail('')
  setSignupPlan('free')

  if (error) {
    showToast('Could not create account')
    return
  }

  showToast('Account created! Let’s build your setup.')

  fetchProfiles()

  setTimeout(() => {
    switchUser(data)
  }, 900)
}
*/}

async function createTaskFromEngine(taskData) {

  // Convert JavaScript Date -> database date string (YYYY-MM-DD)
  const dueDate =
    taskData.due_date instanceof Date
      ? taskData.due_date.toISOString().split('T')[0]
      : taskData.due_date

  const taskToInsert = {
    ...taskData,
    due_date: dueDate
  }

  console.log("🧱 TASK READY FOR INSERT:", {
    name: taskToInsert.name,
    recurring_task_id: taskToInsert.recurring_task_id,
    focus_area_id: taskToInsert.focus_area_id,
    project_id: taskToInsert.project_id,
    context_id: taskToInsert.context_id,
    location_id: taskToInsert.location_id
  })

  console.log(
    'ENGINE DUE DATE:',
    taskData.due_date,
    '→ Database Date:',
    dueDate
  )

  // Final duplicate check in the database
  const { data: existing, error: lookupError } =
    await supabase
      .from('tasks')
      .select('id')
      .eq('user_id', taskToInsert.user_id)
      .eq(
        'recurring_task_id',
        taskToInsert.recurring_task_id
      )
      .eq(
        'due_date',
        taskToInsert.due_date
      )
      .limit(1)

  if (lookupError) {
    console.error(lookupError)
    throw new Error(lookupError.message)
  }

  // Already exists — return the existing Task
  if (existing && existing.length > 0) {
    return existing[0]
  }

  // Safe to insert
  const { data, error } =
    await supabase
      .from('tasks')
      .insert([taskToInsert])
      .select()

  if (error) {
    console.error(error)
    throw new Error(error.message)
  }

  return data?.[0] || null
}

async function updateRecurringTemplate(id, updates) {

  const { data, error } =
    await supabase
      .from('recurring_tasks')
      .update(updates)
      .eq('id', id)
      .select()

  if (error) {
    console.error(
      'Template update failed:',
      error
    )
  }
}

async function updateTask(taskId, updates) {

  // If is_completed is being changed, automatically manage completed_at
  if ('is_completed' in updates) {
    updates.completed_at = updates.is_completed
      ? new Date().toISOString()
      : null
  }

  const { error } = await supabase
    .from('tasks')
    .update(updates)
    .eq('id', taskId)

  if (error) {
    console.error(error)
  }
}


async function runRecurringTasksNow(
  recurringTemplates = [],
  existingTasks = []
) {
  if (recurringEngineRunning.current) return

  recurringEngineRunning.current = true

  try {


    await runRecurringEngine({
      currentUser,
      recurringTemplates,
      existingTasks,
      updateTask,
      createTask: createTaskFromEngine,
      updateTemplate: updateRecurringTemplate
    })
  } finally {
    recurringEngineRunning.current = false
  }
}

async function loadRecurringTemplates() {
  const { data } = await supabase
    .from('onboarding_recurring_templates')
    .select('*')
    .eq('is_active', true)
    .order('sort_order', { ascending: true })

  if (data) {
    setRecurringTemplates(data)
  }
}

 async function fetchTasks() {
  if (!currentUser) return

  console.log('FETCH TASKS RUNNING')
  console.log('ACTIVE UNIVERSAL FILTER:', activeUniversalFilter)

  let query = supabase
    .from('tasks')
    .select(`
      *,
      task_times(name),
      task_types(name),
      time_of_day_levels(name, sort_order),
      status_levels(name),
      impact_levels(name),
      capacity_levels(name),
      day_type_levels(name),
      priority_levels(name),
      projects(name),
      context(name)
    `)
    .eq('user_id', currentUser.id)

  // Apply Universal Filter
  if (activeUniversalFilter) {

    // Standard filters such as Work or BluPrint
    if (activeUniversalFilter.focus_area_id) {
      query = query.eq(
        'focus_area_id',
        activeUniversalFilter.focus_area_id
      )
    }

    // Exclusion filters such as Non-Work
    if (activeUniversalFilter.exclude_focus_area_id) {
      query = query.or(
        `focus_area_id.is.null,focus_area_id.neq.${activeUniversalFilter.exclude_focus_area_id}`
      )
    }
  }

  const { data, error } = await query.order('created_at', {
    ascending: false
  })

  console.log('FETCH TASKS RESULT:', {
    count: data?.length,
    error,
    activeUniversalFilter
  })

  if (error) {
    console.error('FETCH TASKS ERROR:', error)
    return
  }

  console.log('FETCH TASKS DATA:', data)

  setTasks(hydrateTasks(data))
}

useEffect(() => {
  if (!currentUser) return

  fetchTasks()
}, [currentUser, activeUniversalFilter])

async function fetchAllTasks() {
  if (!currentUser) return []

  const { data, error } = await supabase
    .from('tasks')
    .select('*')
    .eq('user_id', currentUser.id)

  if (error) {
    console.error('Error fetching tasks:', error)
    return []
  }

  setAllTasks(data)
  return data
}

  async function fetchTaskTypes() {
    const { data, error } = await supabase.from('task_types').select('*')
    if (!error) setTaskTypes(data)
  }

  async function fetchTaskTimes() {
    const { data, error } = await supabase.from('task_times').select('*')
    if (!error) setTaskTimes(data)
  }

  async function fetchRecurrenceTypes() {
  const { data, error } = await supabase
    .from('recurrence_types')
    .select('*')
    .order('id')

  if (!error) setRecurrenceTypes(data)
}

async function fetchRecurringTasks() {

  //debugger;
  if (!currentUser) return []

  let query = supabase
    .from('recurring_tasks')
    .select(`
      *,
      recurrence_types(id, name),
      priority_levels(id, name),
      task_times(id, name),
      status_levels(name),
      projects(id, name),
      context(id, name),
      focus_area(id, name),
      locations(id, name),
      time_of_day_levels(name, sort_order),
      impact_levels(id, name),
      capacity_levels(id, name),
      day_type_levels(id, name),
      seasons(
        id,
        name,
        start_month,
        start_day,
        end_month,
        end_day,
        is_active
      )
    `)
    .eq('user_id', currentUser.id)

  // Apply Universal Filter
  if (activeUniversalFilter) {

    // Standard filters such as Work or BluPrint
    if (activeUniversalFilter.focus_area_id) {
      query = query.eq(
        'focus_area_id',
        activeUniversalFilter.focus_area_id
      )
    }

    // Exclusion filters such as Non-Work
    if (activeUniversalFilter.exclude_focus_area_id) {
      query = query.or(
        `focus_area_id.is.null,focus_area_id.neq.${activeUniversalFilter.exclude_focus_area_id}`
      )
    }
  }

  const { data, error } = await query.order('created_at', {
    ascending: false
  })

  if (error) {
    console.error(
      'Error fetching recurring tasks:',
      error
    )
    return []
  }

  console.log(
    'RECURRING TASKS WITH SEASONS:',
    data
  )

  setRecurringTasksList(
    hydrateRecurringTasks(data)
  )

  return data || []
}

async function fetchAllRecurringTasks() {
  if (!currentUser) return []

  const { data, error } = await supabase
    .from('recurring_tasks')
    .select(`
      *,
      recurrence_types(id, name),
      priority_levels(id, name),
      task_times(id, name),
      status_levels(name),
      projects(id, name),
      context(id, name),
      focus_area(id, name),
      locations(id, name),
      time_of_day_levels(name, sort_order),
      impact_levels(id, name),
      capacity_levels(id, name),
      day_type_levels(id, name),
      seasons(
        id,
        name,
        start_month,
        start_day,
        end_month,
        end_day,
        is_active
      )
    `)
    .eq('user_id', currentUser.id)

  if (error) {
    console.error(
      'Error fetching all recurring tasks:',
      error
    )
    return []
  }

  return data || []
}

function getRecurrenceSummary(task) {
  if (!task) return ''

  // 🔥 INTERVAL FIRST (global + seasonal)
  if (task.interval_value && task.interval_unit) {
    const unit =
      Number(task.interval_value) === 1
        ? task.interval_unit.slice(0, -1)
        : task.interval_unit

    // If seasonal, include season name
    if (task.recurrence_type_id === 5) {
      const seasonName =
        task.seasons?.name ||
        task.season_name ||
        'season'

      return `Every ${task.interval_value} ${unit} during ${seasonName}`
    }

    return `Every ${task.interval_value} ${unit}`
  }
  
  const type = task.recurrence_types?.name || ''

  // DAILY
  if (type === 'Daily') return 'Every day'

  // WEEKLY
  if (type === 'Weekly') {
    if (task.days_of_week && task.days_of_week.length > 0) {
      const days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
      const selected = task.days_of_week.map(d => days[d])

      if (selected.length === 7) return 'Every day'
      if (selected.join(',') === 'Mon,Tue,Wed,Thu,Fri') return 'Every weekday'
      if (selected.join(',') === 'Sun,Sat') return 'Every weekend'

      return `Every ${selected.join(' & ')}`
    }

    if (task.day_of_week !== null && task.day_of_week !== undefined) {
      const days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
      return `Every ${days[task.day_of_week]}`
    }

    return 'Every week'
  }

  // MONTHLY
  if (type === 'Monthly') {
    return `Every month on day ${task.day_of_month}`
  }

  // YEARLY
  if (type === 'Yearly') {
    return 'Every year'
  }

  // SEASONAL
  if (task.recurrence_type_id === 5) {
  let text = ''

  // 👉 PRIORITY 1: interval
  if (task.interval_value && task.interval_unit) {
    const unit =
      task.interval_value === 1
        ? task.interval_unit.slice(0, -1) // day instead of days
        : task.interval_unit

    text = `Every ${task.interval_value} ${unit}`

  } else {
    // 👉 FALLBACK: frequency
    const freq = (task.seasonal_frequency || '').toLowerCase()

    if (freq === 'daily') text = 'Daily'
    else if (freq === 'weekly') text = 'Weekly'
    else if (freq === 'monthly') text = 'Monthly'
    else if (freq === 'once') text = 'Once per season'
    else text = 'Seasonal'
  }

  // 👉 Add season name
  const seasonName =
    task.seasons?.name ||
    task.season_name ||
    'season'

  return `${text} during ${seasonName}`
}
}

function getOrdinal(n) {
  if (n > 3 && n < 21) return 'th'
  switch (n % 10) {
    case 1: return 'st'
    case 2: return 'nd'
    case 3: return 'rd'
    default: return 'th'
  }
}

const months = [
  { value: 1, name: 'January' },
  { value: 2, name: 'February' },
  { value: 3, name: 'March' },
  { value: 4, name: 'April' },
  { value: 5, name: 'May' },
  { value: 6, name: 'June' },
  { value: 7, name: 'July' },
  { value: 8, name: 'August' },
  { value: 9, name: 'September' },
  { value: 10, name: 'October' },
  { value: 11, name: 'November' },
  { value: 12, name: 'December' }
]

async function loadOnboardingTemplates() {
  const { data: locs } = await supabase
    .from('onboarding_location_templates')
    .select('*')
    .eq('is_active', true)
    .order('sort_order')

  const { data: ctx } = await supabase
    .from('onboarding_context_templates')
    .select('*')
    .eq('is_active', true)
    .order('sort_order')

  const { data: foc } = await supabase
    .from('onboarding_focus_templates')
    .select('*')
    .eq('is_active', true)
    .order('sort_order')

  const { data: rec } = await supabase
    .from('onboarding_recurring_templates')
    .select('*')
    .eq('is_active', true)
    .order('sort_order')

  setLocationTemplates(locs || [])
  setContextTemplates(ctx || [])
  setFocusTemplates(foc || [])
  setRecurringTemplates(rec || [])
}


async function fetchSeasons() {
  if (!currentUser) return

  const { data, error } = await supabase
    .from('seasons')
    .select('*')
    .eq('user_id', currentUser.id)
    .order('start_month', { ascending: true })

  if (error) {
    console.error(error)
    return
  }

  setSeasons(data || [])
}

function addCustomLocation() {
  const value = customLocation.trim()
  if (!value) return

  setSelectedLocations([
    ...selectedLocations,
    value
  ])

  setCustomLocation('')
}

async function createDefaultSeasons(userId) {
  const defaultSeasons = [
    {
      name: 'Spring',
      start_month: 3,
      start_day: 20,
      end_month: 6,
      end_day: 20,
      notes: 'Season of growth and renewal.',
      is_active: true
    },
    {
      name: 'Summer',
      start_month: 6,
      start_day: 21,
      end_month: 9,
      end_day: 21,
      notes: 'Season of energy and abundance.',
      is_active: true
    },
    {
      name: 'Fall',
      start_month: 9,
      start_day: 22,
      end_month: 12,
      end_day: 20,
      notes: 'Season of harvest and reflection.',
      is_active: true
    },
    {
      name: 'Winter',
      start_month: 12,
      start_day: 21,
      end_month: 3,
      end_day: 19,
      notes: 'Season of rest and restoration.',
      is_active: true
    }
  ]

  const rows = defaultSeasons.map((season) => ({
    ...season,
    user_id: userId
  }))

  const { error } = await supabase
    .from('seasons')
    .insert(rows)

  if (error) {
    console.error('Error creating default seasons:', error)
    showToast('Could not create default seasons.')
  }
}

function resetOnboarding() {
  setSelectedLocations([])
  setSelectedContexts([])
  setSelectedFocus([])
  setSelectedRecurring([])

  setCustomContext('')
  setCustomFocus('')
  setCustomLocation('')
}

async function completeOnboarding() {
  if (!currentUser) return

  // LOCATIONS
  for (const item of selectedLocations) {
    if (typeof item === 'string') {
      // custom location
      await supabase.from('locations').insert({
        name: item,
        user_id: currentUser.id
      })
    } else {
      // template location id
      const match = locationTemplates.find(
        loc => loc.id === item
      )

      if (match) {
        await supabase.from('locations').insert({
          name: match.name,
          user_id: currentUser.id
        })
      }
    }
  }

  // CONTEXTS
  for (const name of selectedContexts) {
    await supabase.from('context').insert({
      name,
      user_id: currentUser.id
    })
  }

  if (customContext.trim()) {
    await supabase.from('context').insert({
      name: customContext.trim(),
      user_id: currentUser.id
    })
  }

  // FOCUS AREAS
  for (const name of selectedFocus) {
    await supabase.from('focus_area').insert({
      name,
      user_id: currentUser.id
    })
  }

  if (customFocus.trim()) {
    await supabase.from('focus_area').insert({
      name: customFocus.trim(),
      user_id: currentUser.id
    })
  }
  //RECURRING TASKS
  for (const id of selectedRecurring) {
  const match = recurringTemplates.find(
    item => item.id === id
  )

  if (match) {
    let recurrenceId = 1

    if (match.category === 'Weekly') recurrenceId = 2
    if (match.category === 'Monthly') recurrenceId = 3
    if (match.category === 'Yearly') recurrenceId = 4

    await supabase.from('recurring_tasks').insert({
      name: match.name,
      notes: match.notes || '',
      recurrence_type_id: recurrenceId,
      is_active: true,
      is_pausable: true,
      user_id: currentUser.id
    })
  }
}


// CREATE DEFAULT SEASONS
await createDefaultSeasons(currentUser.id)

  // MARK ONBOARDING COMPLETE
  await supabase
    .from('profiles')
    .update({ onboarding_complete: true })
    .eq('id', currentUser.id)

  // REFRESH DATA
  fetchLocations()
  fetchContexts()
  fetchFocusAreas()
  fetchProfiles()

  // RESET ONBOARDING FORM
  resetOnboarding()

  // GO TO TASKS PAGE
    setPage('tasks')
}

async function handleSignUp() {
  // Basic validation
  if (
    !signupFirst.trim() ||
    !signupLast.trim() ||
    !signupDisplay.trim() ||
    !signupEmail.trim() ||
    !signupPassword.trim()
  ) {
    showToast('Please complete all required fields.')
    return
  }

  // Create account in Supabase Auth
  const { data, error } = await supabase.auth.signUp({
    email: signupEmail.trim(),
    password: signupPassword,
    options: {
      data: {
        first_name: signupFirst.trim(),
        middle_name: signupMiddle.trim(),
        last_name: signupLast.trim(),
        display_name: signupDisplay.trim()
      }
    }
  })

  if (error) {
    console.error('Sign up error:', error)
    showToast(error.message)
    return
  }

  const newUser = data.user

  if (!newUser) {
    showToast('Account created. Please check your email to confirm.')
    return
  }

    // Get the next BluPrint ID
const { data: profilesData } = await supabase
  .from('profiles')
  .select('bluprint_id')

const nextId =
  Math.max(
    0,
    ...profilesData.map(p => p.bluprint_id || 0)
  ) + 1

  // Create profile record
  const { error: profileError } = await supabase
    .from('profiles')
    .insert({
      id: newUser.id,
      bluprint_id: nextId,
      email: signupEmail.trim(),
      first_name: signupFirst.trim(),
      middle_name: signupMiddle.trim() || null,
      last_name: signupLast.trim(),
      display_name: signupDisplay.trim(),
      plan_type: signupPlan || 'free',
      timezone: 'America/Denver',
      is_active: true,
      onboarding_complete: false,
      beta_tester: false,
      is_admin: false,
      created_at: new Date().toISOString()
    })

  if (profileError) {
    console.error('Profile creation error:', profileError)
    //showToast('Account created, but profile could not be created.')
    showToast(profileError.message)
    return
  }

  // Create default user_preferences row
  await supabase
    .from('user_preferences')
    .insert({
      user_id: newUser.id
    })

  // Create 7 weekly schedule rows (Sunday = 0 through Saturday = 6)
  const weeklyRows = Array.from({ length: 7 }, (_, i) => ({
    user_id: newUser.id,
    day_of_week: i
  }))

  await supabase
    .from('user_weekly_schedule')
    .insert(weeklyRows)

  // Clear signup form
  setSignupFirst('')
  setSignupMiddle('')
  setSignupLast('')
  setSignupDisplay('')
  setSignupEmail('')
  setSignupPassword('')

  showToast('Account created successfully!')

  // Refresh profiles and move to onboarding
  await fetchProfiles()

  // Refresh the authenticated user through AuthProvider.
  // AuthProvider is the single owner of currentUser.
  const profile = await refreshCurrentUser()

  if (!profile) {
    showToast('Account was created, but we could not load your profile.')
    return
  }

  setPage('onboarding')
}

async function setPauseMode(value) {

  const { data, error } = await supabase
  .from('user_preferences')
  .update({
    pause_mode: value
  })

    .eq('user_id', currentUser.id)

  setPausedMode(value)
  showToast(value ? '⏸ Paused Mode Enabled' : '▶️ Paused Mode Disabled')
}

function startTaskFromInbox(item) {
  // Load the captured item into the existing Task form
  setNewTask(item.name || '')
  setNotes(item.notes || '')

  // A newly classified item starts in Needs Clarification
  setStatusId(10)

  // Leave the remaining task details available for the user to fill in
  setDueDate('')
  setTaskTime(null)
  setProjectId('')
  setPriorityId('')
  setContextId('')
  setFocusAreaId('')
  setLocationId('')
  setTimeOfDayId('')
  setImpactId('')
  setCapacityId('')
  setDayTypeId('')

  // Remember which inbox item this task came from
  setPendingInboxId(item.id)

  // Take the user to the existing Task form
  setPage('tasks')
}

async function addTask() {

  if (!currentUser) return
  if (!newTask.trim()) return

  // Needs Clarification is a temporary state for items
  // coming from Clarify. If the user leaves it there,
  // save the completed task as Active.
  const selectedStatusId = statusId ? Number(statusId) : 1

  const finalStatusId =
    selectedStatusId === 10
      ? 1
      : selectedStatusId

  const reviewStatus = calculateReviewStatus({
    project_id: projectId,
    status_id: finalStatusId,
    context_id: contextId,
    focus_area_id: focusAreaId,
    task_time_id: taskTime,
    priority_id: priorityId,
    location_id: locationId,
    time_of_day_id: timeOfDayId,
    impact_id: impactId,
    capacity_id: capacityId,
    day_type_id: dayTypeId,
    due_date: dueDate
  })

  const { data, error } = await supabase
    .from('tasks')
    .insert([
      {
        name: newTask,
        user_id: currentUser.id,

        task_type_id: taskType || null,
        due_date: dueDate || null,
        task_time_id: taskTime || null,
        priority_id: priorityId || null,
        status_id: finalStatusId,
        context_id: contextId || null,
        focus_area_id: focusAreaId || null,
        location_id: locationId || null,
        notes: notes || null,
        project_id: projectId || null,

        time_of_day_id: timeOfDayId || null,
        impact_id: impactId || null,
        capacity_id: capacityId || null,
        day_type_id: dayTypeId || null,

        review_status: reviewStatus,
      }
    ])
    .select()
    .single()

  if (error) {
    console.error(error)
    showToast('❌ Could not add task')
    return
  }

  // EVENT LOGGING
  await logTaskEvent({
    taskId: data.id,
    userId: currentUser.id,

    eventType: 'created',

    toStatusId: finalStatusId,

    metadata: {
      taskName: newTask
    }
  })

  // If this task came from Quick Capture / Clarify,
  // mark the original inbox item as processed ONLY
  // after the task was successfully created.
  if (pendingInboxId) {
    const { error: inboxError } = await supabase
      .from('inbox')
      .update({
        processed_at: new Date().toISOString(),
        converted_to_type: 'task',
        converted_to_id: data.id
      })
      .eq('id', pendingInboxId)

    if (inboxError) {
      console.error('Could not mark inbox item processed:', inboxError)
      showToast('⚠️ Task saved, but inbox item could not be marked processed')
    }
  }

  setPendingInboxId(null)

  resetTaskForm()

  fetchTasks()

  showToast('✅ Task added')
}

async function saveTaskEdits() {

  const reviewStatus = calculateReviewStatus({
    project_id: projectId,
    status_id: statusId,
    context_id: contextId,
    focus_area_id: focusAreaId,
    task_time_id: taskTime,
    priority_id: priorityId,
    location_id: locationId,
    time_of_day_id: timeOfDayId,
    impact_id: impactId,
    capacity_id: capacityId,
    day_type_id: dayTypeId,
    due_date: dueDate
  })

  const { error } = await supabase
    .from('tasks')
    .update({
      name: newTask,
      due_date: dueDate || null,

      task_time_id: taskTime || null,
      priority_id: priorityId || null,
      status_id: statusId || null,

      context_id: contextId || null,
      focus_area_id: focusAreaId || null,
      location_id: locationId || null,

      project_id: projectId || null,

      notes: notes || null,

      time_of_day_id: timeOfDayId || null,
      impact_id: impactId || null,
      capacity_id: capacityId || null,
      day_type_id: dayTypeId || null,

      review_status: reviewStatus,
    })
    .eq('id', editingTaskId)

  if (error) {
    console.error(error)
    return
  }

  resetTaskForm()
  fetchTasks()

  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

  async function fetchPriorityLevels() {
  const { data, error } = await supabase
    .from('priority_levels')
    .select('*')
    .order('sort_order')

  if (!error) setPriorityLevels(data)
}

async function fetchStatusLevels() {
  const { data, error } = await supabase
    .from('status_levels')
    .select('*')
    .order('sort_order')

  if (!error) setStatusLevels(data)
}

async function fetchTimeOfDayLevels() {
  const { data, error } = await supabase
    .from('time_of_day_levels')
    .select('*')
    .order('sort_order', { ascending: true })

  if (!error) setTimeOfDayLevels(data)
}

async function fetchImpactLevels() {
  const { data, error } = await supabase
    .from('impact_levels')
    .select('*')
    .order('id')

  if (!error) setImpactLevels(data)
}

async function fetchCapacityLevels() {
  const { data, error } = await supabase
    .from('capacity_levels')
    .select('*')
    .order('id')

  if (!error) setCapacityLevels(data)
}

async function fetchDayTypeLevels() {
  const { data, error } = await supabase
    .from('day_type_levels')
    .select('*')
    .order('id')

  if (!error) setDayTypeLevels(data)
}

  async function toggleTask(task) {

  const becomingComplete =
    !task.is_completed

  const newStatus =
    becomingComplete ? 6 : 1

  await supabase
    .from('tasks')
    .update({
      is_completed: becomingComplete,
      completed_at: becomingComplete
        ? new Date().toISOString()
        : null,
      status_id: newStatus
    })
    .eq('id', task.id)

  // 🔥 EVENT LOGGING
  await logTaskEvent({
    taskId: task.id,
    recurringTaskId: task.recurring_task_id,
    userId: currentUser.id,

    eventType:
      becomingComplete
        ? 'completed'
        : 'reopened',

    fromStatusId: task.status_id,
    toStatusId: newStatus,

    metadata: {
      taskName: task.name
    }
  })

  // recurring template updates
  if (
    becomingComplete &&
    task.recurring_task_id
  ) {

    const template =
      recurringTasksList.find(
        item =>
          item.id === task.recurring_task_id
      )

    if (template) {

      const updates =
        updateTemplateAfterCompletion(template)

      await updateRecurringTemplate(
        template.id,
        updates
      )
    }
  }

  fetchTasks()
}

async function skipTask(task) {
  await supabase
    .from('tasks')
    .update({
      is_completed: false,
      status_id: 8
      
    })
    .eq('id', task.id)

    await logTaskEvent({
      taskId: task.id,
      recurringTaskId: task.recurring_task_id,
      userId: currentUser.id,

      eventType: 'skipped',

      fromStatusId: task.status_id,
      toStatusId: 8,

      metadata: {
        taskName: task.name
      }
    })
  fetchTasks()
}

 async function generateFocusBlocks(goToTasks = true) {
  if (!currentUser) return
  const count = Number(focusCount) || 1

  if (!focusTaskTime) {
    showToast('⏱️ Choose a task time')
    return
  }

  if (!focusBlockValue) {
    showToast('📌 Choose a focus value')
    return
  }

  const rows = []

  for (let i = 1; i <= count; i++) {
    const task = {
  name: `${getFocusTypeLabel()} - ${getFocusLabel()} - Focus Block ${i}`,
  user_id: currentUser.id,
  is_completed: false,
  task_time_id: Number(focusTaskTime),
  status_id: 1
}

    if (focusBlockType === 'project') {
      task.project_id = Number(focusBlockValue)
    }

    if (focusBlockType === 'location') {
      task.location_id = Number(focusBlockValue)
    }

    if (focusBlockType === 'context') {
      task.context_id = Number(focusBlockValue)
    }

    if (focusBlockType === 'focusArea') {
      task.focus_area_id = Number(focusBlockValue)
    }

    rows.push(task)
  }

  const { error } = await supabase
    .from('tasks')
    .insert(rows)

  if (error) {
    console.error(error)
    showToast('❌ Could not generate focus blocks')
    return
  }

  await fetchTasks()

  if (goToTasks) {
  setPage('tasks')
}

  setFocusBlockType('project')
  setFocusBlockValue('')
  setFocusCount(3)
  setFocusTaskTime('')

  showToast('🚀 Focus Blocks Generated')
  }


  // LEGACY
// DO NOT MODIFY
// Scheduled for removal

async function generateRecurringTasks() {

  alert('Wrapper reached')

  try {
    await runRecurringTasksNow()

    alert('Engine completed')
  }
  catch (err) {
    console.error(err)

    alert(
      'Engine Error: ' +
      JSON.stringify(err)
    )
  }
}

function resetRecurringForm() {
  setEditingRecurringId(null)
  setNewRecurringTask('')
  setRecurrenceType(1)
  setRecurringNotes('')
  setRecurringProjectId('')
  setRecurringPriorityId('')
  setRecurringTaskTime('')
  setRecurringStatusId('')
  setRecurringContextId('')
  setRecurringFocusAreaId(defaultFocusAreaId || '')
  setRecurringLocationId('')
  setRecurringIsActive(true)
  setRecurringIsPausable(true)

  setRecurringDayOfWeek('')
  setRecurringDayOfMonth('')

  setRecurringMonthlyRuleType('day_of_month')
  setRecurringMonthlyWeekday('')
  setRecurringMonthlyWeekNumbers([])

  setRecurringMonthOfYear('')
  setRecurringDaysOfWeek([])
  setRecurringIntervalValue('')
  setRecurringIntervalUnit('days')

  setRecurringSeasonId('')
  setSeasonalFrequency('')

  setRecurringTimeOfDayId(defaultDailyFlowId || '')
  setRecurringImpactId('')
  setRecurringCapacityId('')
  setRecurringDayTypeId(defaultDayTypeId || '')

  // New recurring options
  setRecurrenceAnchorType('calendar')
  setPersistenceType('keep_until_done')
  setRecurrenceStartDate(
      formatDate(operationalToday)
    )
  setRecurrenceEndDate('')
  setLastReviewedAt('')
}

async function addRecurringTask() {

  if (!currentUser) return
  if (!newRecurringTask.trim()) return

  const finalStatusId =
    [1, 10].includes(Number(recurringStatusId))
      ? 1
      : recurringStatusId || null

  const payload = {
    name: newRecurringTask,
    user_id: currentUser.id,
    recurrence_type_id: Number(recurrenceType),

    task_type_id: taskType || null,
    task_time_id: recurringTaskTime || null,
    priority_id: recurringPriorityId || null,
    status_id: finalStatusId,

    project_id: recurringProjectId || null,
    context_id: recurringContextId || null,
    focus_area_id: recurringFocusAreaId || null,
    location_id: recurringLocationId || null,

    time_of_day_id: recurringTimeOfDayId || null,
    impact_id: recurringImpactId || null,
    capacity_id: recurringCapacityId || null,
    day_type_id: recurringDayTypeId || null,

    interval_value: recurringIntervalValue || null,

    day_of_month:
      [3, 4].includes(Number(recurrenceType))
        ? recurringDayOfMonth || null
        : null,

    days_of_week:
      Number(recurrenceType) === 2 &&
      recurringDaysOfWeek.length > 0
        ? recurringDaysOfWeek
        : null,

    month_of_year:
      Number(recurrenceType) === 4
        ? recurringMonthOfYear || null
        : null,

    monthly_rule_type:
      Number(recurrenceType) === 3
        ? recurringMonthlyRuleType || null
        : null,

    monthly_weekday:
      Number(recurrenceType) === 3 &&
      recurringMonthlyRuleType === 'nth_weekday'
        ? recurringMonthlyWeekday || null
        : null,

    monthly_week_numbers:
      Number(recurrenceType) === 3 &&
      recurringMonthlyRuleType === 'nth_weekday' &&
      recurringMonthlyWeekNumbers.length > 0
        ? recurringMonthlyWeekNumbers
        : null,

    season_id: recurringSeasonId || null,

    is_active: recurringIsActive,
    is_pausable: recurringIsPausable,

    recurrence_anchor_type: recurrenceAnchorType || 'calendar',
    persistence_type: persistenceType || 'keep_until_done',

    recurrence_start_date: recurrenceStartDate || null,
    recurrence_end_date: recurrenceEndDate || null,
    last_reviewed_at: lastReviewedAt || null,

    notes: recurringNotes || null
  }

  let error
  let savedRecurringId = null

  if (editingRecurringId) {

    const result = await supabase
      .from('recurring_tasks')
      .update(payload)
      .eq('id', editingRecurringId)

    error = result.error
    savedRecurringId = editingRecurringId

  } else {

    const result = await supabase
      .from('recurring_tasks')
      .insert([payload])
      .select()
      .single()

    error = result.error
    savedRecurringId = result.data?.id
  }

  if (error) {
    console.error('Recurring task save error:', error)
    alert('Error saving recurring task: ' + error.message)
    return
  }

  // If this recurring task came from Clarify,
  // mark the original inbox item as processed.
  if (!editingRecurringId && pendingInboxId && savedRecurringId) {

    const { error: inboxError } = await supabase
      .from('inbox')
      .update({
        processed_at: new Date().toISOString(),
        converted_to_type: 'recurring',
        converted_to_id: savedRecurringId
      })
      .eq('id', pendingInboxId)

    if (inboxError) {
      console.error('Error processing inbox item:', inboxError)
    }

    setPendingInboxId(null)
  }

  resetRecurringForm()
  fetchRecurringTasks()
}


const filteredTasks = tasks
  .filter(task => {
  
  const todayDate = operationalToday

  const today =
    todayDate.getFullYear() +
    '-' +
    String(todayDate.getMonth() + 1).padStart(2, '0') +
    '-' +
    String(todayDate.getDate()).padStart(2, '0')

  const matchesStatus =
  statusFilter === 'all' ||

  (
  statusFilter === 'active' &&
  !task.is_completed &&
  (
    !task.status?.name ||
    task.status.name === 'Active'
  )
) ||

  (
    statusFilter === 'nextup' &&
    task.status?.name === 'Next Up'
  ) ||

  (
    statusFilter === 'later' &&
    task.status?.name === 'Later'
  ) ||

  (
    statusFilter === 'waiting' &&
    task.status?.name === 'Waiting For'
  ) ||

  (
    statusFilter === 'monitor' &&
    task.status?.name === 'Monitor'
  ) ||

  (
    statusFilter === 'completed' &&
    task.is_completed
  )
  if (!matchesStatus) return false

  const matchesSearch =
    task.name.toLowerCase().includes(searchText.toLowerCase()) ||
    (task.notes || '').toLowerCase().includes(searchText.toLowerCase())

  if (!matchesSearch) return false

  const matchesFocus =
    focusFilter === 'all' ||
    String(task.focus_area_id) === String(focusFilter)

  if (!matchesFocus) return false

  const matchesProject =
    !taskFilterProject ||
    String(task.project_id) === String(taskFilterProject)

  if (!matchesProject) return false

  if (smartView === 'today') {
     console.log(
    'TODAY CHECK:',
    task.name,
    task.due_date,
    today,
    task.due_date?.startsWith(today)
  )
    return task.due_date && task.due_date.startsWith(today)
  }

  if (smartView === 'anytime') {
    return (
      task.timeOfDay?.name === 'Anytime'
    )
  }

  if (smartView === 'review') {
    return (
      task.due_date &&
      task.due_date < today &&
      !task.is_completed
    )
  }

  if (smartView === 'quick') {
    return task.duration?.name?.includes('10')
  }

  if (smartView === 'focus') {
    return task.name.toLowerCase().includes('focus block')
  }

  return true
})
.sort((a, b) => {
  if (sortBy === 'az') {
    return a.name.localeCompare(b.name)
  }

  if (sortBy === 'za') {
    return b.name.localeCompare(a.name)
  }

  if (sortBy === 'timeOfDay') {

    const aOrder =
      a.time_of_day_levels?.sort_order || 999

    const bOrder =
      b.time_of_day_levels?.sort_order || 999

    return aOrder - bOrder
  }

  if (sortBy === 'newest') {
    return b.id - a.id
  }

  if (sortBy === 'oldest') {
    return a.id - b.id
  }

    


  return 0
})

const filteredRecurringTasks = recurringTasksList
  .filter(task => {

    // Hide archived recurring tasks from the normal view
    if (Number(task.status_id) === 11) return false

    const matchesSearch =
      task.name.toLowerCase().includes(recurringSearch.toLowerCase()) ||
      (task.notes || '')
        .toLowerCase()
        .includes(recurringSearch.toLowerCase())

    if (!matchesSearch) return false

    const matchesFocus =
      recurringFocusFilter === 'all' ||
      String(task.focus_area_id) === String(recurringFocusFilter)

    if (!matchesFocus) return false

    const matchesLocation =
      recurringLocationFilter === 'all' ||
      String(task.location_id) === String(recurringLocationFilter)

    if (!matchesLocation) return false

    return true
  })

  .sort((a, b) => {

    if (recurringSortBy === 'az') {
      return a.name.localeCompare(b.name)
    }

    if (recurringSortBy === 'za') {
      return b.name.localeCompare(a.name)
    }

    if (recurringSortBy === 'dailyflow') {
      const aOrder =
        a.time_of_day_levels?.sort_order || 999

      const bOrder =
        b.time_of_day_levels?.sort_order || 999

      return aOrder - bOrder
    }

    if (recurringSortBy === 'newest') {
      return b.id - a.id
    }

    if (recurringSortBy === 'oldest') {
      return a.id - b.id
    }

    return 0
  })

  const completedToday = tasks.filter(task => {
    if (!task.completed_at) return false
    return (
        formatDate(task.completed_at) ===
        formatDate(operationalToday)
      )
  }).length

  const totalCompleted = tasks.filter(t => t.is_completed).length

  function getTaskTypeName(id) {
    const type = taskTypes.find(t => t.id === id)
    return type ? type.name : ''
  }

  function getSeasonName(id) {
  const season = seasons.find(s => s.id === id)
  return season ? season.name : ''
}

function formatLabel(text) {
  if (!text) return ''
  return text.charAt(0).toUpperCase() + text.slice(1)
}

async function deleteRecurringTask(id) {
  const confirmed = window.confirm(
    'Archive this recurring task?'
  )

  if (!confirmed) return

  const { error } = await supabase
    .from('recurring_tasks')
    .update({
      status_id: 11,
      is_active: false
    })
    .eq('id', id)

  if (error) {
    console.error(error)
    alert(error.message)
    return
  }

  if (editingRecurringId === id) {
    setEditingRecurringId(null)

    setNewRecurringTask('')
    setRecurrenceType(1)
    setRecurringNotes('')
    setRecurringProjectId('')
    setRecurringPriorityId('')
    setRecurringTaskTime('')
    setRecurringContextId('')
    setRecurringFocusAreaId('')
    setRecurringLocationId('')
    setRecurringIsActive(true)
    setRecurringIsPausable(true)
    setRecurringDayOfWeek('')
    setRecurringDayOfMonth('')
    setRecurringMonthOfYear('')
    setRecurringSeasonId('')
    setSeasonalFrequency('')
  }

  fetchRecurringTasks()
}

  async function deleteTask(id) {
  const confirmed = window.confirm('Delete this task?')

  if (!confirmed) return

  const { error } = await supabase
    .from('tasks')
    .delete()
    .eq('id', id)

  if (error) {
    console.error(error)
    return
  }

  fetchTasks()
  showToast('🗑️ Task deleted')
}

function startEdit(task) {
  setEditingTaskId(task.id)

  setNewTask(task.name || '')
  setDueDate(task.due_date || '')

  setTaskTime(task.task_time_id?.toString() || '')
  setPriorityId(task.priority_id?.toString() || '')
  setStatusId(task.status_id?.toString() || '')

  setProjectId(task.project_id?.toString() || '')
  setContextId(task.context_id?.toString() || '')
  setFocusAreaId(task.focus_area_id?.toString() || '')
  setLocationId(task.location_id?.toString() || '')

  setNotes(task.notes || '')

  setTimeOfDayId(task.time_of_day_id?.toString() || '')
  setImpactId(task.impact_id?.toString() || '')
  setCapacityId(task.capacity_id?.toString() || '')
  setDayTypeId(task.day_type_id?.toString() || '')

  setPage('tasks')

  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

function startEditRecurring(item) {

          setEditingRecurringId(item.id)
          setRecurringStatusId(item.status_id || '')

          setNewRecurringTask(item.name || '')
          setRecurringNotes(item.notes || '')

          setRecurrenceType(item.recurrence_types?.id || 1)
          setRecurringProjectId(item.projects?.id || '')
          setRecurringPriorityId(item.priority_levels?.id || '')
          setRecurringTaskTime(item.task_times?.id || '')
          setRecurringContextId(item.context?.id || '')
          setRecurringFocusAreaId(item.focus_area?.id || '')
          setRecurringLocationId(item.locations?.id || '')

          setRecurringIsActive(item.is_active ?? true)
          setRecurringIsPausable(item.is_pausable ?? true)

          setRecurringTimeOfDayId(item.time_of_day_id || '')
          setRecurringImpactId(item.impact_id || '')
          setRecurringCapacityId(item.capacity_id || '')
          setRecurringDayTypeId(item.day_type_id || '')

          setRecurringDaysOfWeek(item.days_of_week || [])
          setRecurringDayOfMonth(item.day_of_month || '')

          setRecurringMonthlyRuleType(
            item.monthly_rule_type || 'day_of_month'
          )

          setRecurringMonthlyWeekday(
            item.monthly_weekday ?? ''
          )

          setRecurringMonthlyWeekNumbers(
            Array.isArray(item.monthly_week_numbers)
              ? item.monthly_week_numbers
              : []
          )
          setRecurringMonthOfYear(item.month_of_year || '')

          setRecurringIntervalValue(item.interval_value || '')

          setRecurringSeasonId(item.season_id || '')
          setRecurrenceAnchorType(item.recurrence_anchor_type || 'calendar')
          setPersistenceType(item.persistence_type || 'keep_until_done')

          setRecurrenceStartDate(
            item.recurrence_start_date ||
            formatDate(operationalToday)
          )

          setRecurrenceEndDate(item.recurrence_end_date || '')

          setLastReviewedAt(
            item.last_reviewed_at
              ? item.last_reviewed_at.split('T')[0]
              : ''
          )

          setPage('recurring')

          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
        
}

function resetTaskForm() {
  setEditingTaskId(null)

  setNewTask('')
  setDueDate('')
  setTaskTime('')
  setStatusId(1)

  setProjectId('')
  setPriorityId('')
  setContextId('')
  setFocusAreaId(defaultFocusAreaId || '')
  setLocationId('')

  setNotes('')

  setTimeOfDayId(defaultDailyFlowId || '')
  setImpactId('')
  setCapacityId('')
  setDayTypeId(defaultDayTypeId || '')
}

function getFocusOptions() {
  if (focusBlockType === 'project') return projects
  if (focusBlockType === 'location') return locations
  if (focusBlockType === 'context') return contexts
  if (focusBlockType === 'focusArea') return focusAreas
  return []
}

function getFocusLabel() {
  const item = getFocusOptions().find(
    x => String(x.id) === String(focusBlockValue)
  )

  return item ? item.name : ''
}

function getFocusTypeLabel() {
  if (focusBlockType === 'project') return 'Project'
  if (focusBlockType === 'location') return 'Location'
  if (focusBlockType === 'context') return 'Context'
  if (focusBlockType === 'focusArea') return 'Focus Area'
  return 'Focus'
}

function isDateInSeason(month, day, season) {
  const todayValue = month * 100 + day
  const startValue = season.start_month * 100 + season.start_day
  const endValue = season.end_month * 100 + season.end_day

  // Normal season (Spring: Mar-Jun)
  if (startValue <= endValue) {
    return todayValue >= startValue && todayValue <= endValue
  }

  // Wrap season (Winter: Dec-Mar)
  return todayValue >= startValue || todayValue <= endValue
}

function getCurrentSeason() {
  const now = new Date()
  const month = now.getMonth() + 1
  const day = now.getDate()

  return seasons.find(season =>
    isDateInSeason(month, day, season)
  )
}

async function addSeason() {
  if (!currentUser) return
  if (!seasonName.trim()) {
    showToast('Please enter a season name')
    return
  }

  const payload = {
  name: seasonName,
  user_id: currentUser.id,
  notes: seasonNotes,
  start_month: Number(seasonStartMonth),
  start_day: Number(seasonStartDay),
  end_month: Number(seasonEndMonth),
  end_day: Number(seasonEndDay),
  is_active: seasonIsActive
}

  let error

  if (editingSeasonId) {
    const result = await supabase
      .from('seasons')
      .update(payload)
      .eq('id', editingSeasonId)

    error = result.error
  } else {
    const result = await supabase
      .from('seasons')
      .insert([payload])

    error = result.error
  }

  if (error) {
    console.error(error)
    showToast('Could not save season')
    return
  }

  setEditingSeasonId(null)
  setSeasonName('')
  setSeasonStartMonth('')
  setSeasonStartDay('')
  setSeasonEndMonth('')
  setSeasonEndDay('')
  setSeasonIsActive(true)
  setSeasonNotes('')

  fetchSeasons()
  showToast(editingSeasonId ? 'Season updated!' : 'Season saved!')
}

async function deleteSeason(id) {
  const confirmed = window.confirm(
    'Delete this season?'
  )

  if (!confirmed) return

  const { error } = await supabase
    .from('seasons')
    .delete()
    .eq('id', id)

  if (error) {
    console.error(error)
    showToast('Could not delete season')
    return
  }

  fetchSeasons()
  showToast('Season deleted')
}

function editSeason(season) {
  setEditingSeasonId(season.id)
  setSeasonName(season.name)
  setSeasonStartMonth(season.start_month)
  setSeasonStartDay(season.start_day)
  setSeasonEndMonth(season.end_month)
  setSeasonEndDay(season.end_day)
  setSeasonIsActive(season.is_active)
  setSeasonNotes(season.notes || '')
}

function getSeasonTaskCount(seasonId) {
  return recurringTasksList.filter(
    task => Number(task.season_id) === Number(seasonId)
  ).length
}

async function toggleSeasonActive(season) {
  const { error } = await supabase
    .from('seasons')
    .update({ is_active: !season.is_active })
    .eq('id', season.id)

  if (error) {
    showToast('Could not update season')
    return
  }

  fetchSeasons()
  showToast(
    season.is_active
      ? 'Season deactivated'
      : 'Season activated'
  )
}

function getTasksForSeason(seasonId) {
  return recurringTasksList.filter(
    task => Number(task.season_id) === Number(seasonId)
  )
}

async function saveSeasonTask() {
  if (!currentUser) return

  if (!seasonTaskName.trim() || !selectedSeason) {
    showToast('Please enter a task name')
    return
  }

  const recurrenceMap = {
    daily: 1,
    weekly: 2,
    monthly: 3,
    yearly: 4
  }

  const isOnce =
    seasonTaskRecurrenceType === 'once'

  const recurrenceTypeId =
    isOnce
      ? null
      : recurrenceMap[seasonTaskRecurrenceType]

  if (!isOnce && !recurrenceTypeId) {
    showToast('Please choose a valid recurrence type')
    return
  }

  if (
    !isOnce &&
    (!seasonTaskIntervalValue ||
      Number(seasonTaskIntervalValue) < 1)
  ) {
    showToast('Please enter a valid interval')
    return
  }

  if (
    seasonTaskRecurrenceType === 'monthly' &&
    seasonTaskMonthlyRuleType === 'day_of_month' &&
    (
      !seasonTaskDayOfMonth ||
      Number(seasonTaskDayOfMonth) < 1 ||
      Number(seasonTaskDayOfMonth) > 31
    )
  ) {
    showToast('Please choose a valid day of the month')
    return
  }

  if (
    seasonTaskRecurrenceType === 'monthly' &&
    seasonTaskMonthlyRuleType === 'nth_weekday' &&
    (
      seasonTaskMonthlyWeekday === '' ||
      seasonTaskMonthlyWeekNumbers.length === 0
    )
  ) {
    showToast(
      'Please choose a weekday and week number'
    )
    return
  }

  if (
    seasonTaskRecurrenceType === 'yearly' &&
    (
      !seasonTaskMonthOfYear ||
      !seasonTaskDayOfMonth
    )
  ) {
    showToast(
      'Please choose a month and day'
    )
    return
  }

  const today = new Date()

  const localToday =
    `${today.getFullYear()}-` +
    `${String(today.getMonth() + 1).padStart(2, '0')}-` +
    `${String(today.getDate()).padStart(2, '0')}`

  const payload = {
    name: seasonTaskName.trim(),

    user_id: currentUser.id,

    notes: seasonTaskNotes,

    /*
     * Once is intentionally NOT a recurrence type.
     * A seasonal Once task has:
     *   recurrence_type_id = null
     *   season_id = selected season
     *
     * The recurrence engine will recognize this as
     * one occurrence per season.
     */
    recurrence_type_id: recurrenceTypeId,

    season_id: selectedSeason.id,

    /*
     * Legacy field intentionally left null for all
     * newly-created Season Detail tasks.
     *
     * Existing Seasonal records may still contain
     * this field until we migrate them.
     */
    seasonal_frequency: null,

    /*
     * A newly-created recurring task begins from
     * the day it is created.
     *
     * The Season still controls the allowed calendar
     * window.
     */
    recurrence_start_date: localToday,

    recurrence_end_date: null,

    interval_value:
      isOnce
        ? null
        : Number(seasonTaskIntervalValue) || 1,

    interval_unit: null,

    days_of_week:
      seasonTaskRecurrenceType === 'weekly' &&
      seasonTaskDaysOfWeek.length > 0
        ? seasonTaskDaysOfWeek
        : null,

    day_of_month:
      seasonTaskRecurrenceType === 'monthly' &&
      seasonTaskMonthlyRuleType === 'day_of_month'
        ? Number(seasonTaskDayOfMonth)
        : seasonTaskRecurrenceType === 'yearly'
          ? Number(seasonTaskDayOfMonth)
          : null,

    monthly_rule_type:
      seasonTaskRecurrenceType === 'monthly'
        ? seasonTaskMonthlyRuleType
        : null,

    monthly_weekday:
      seasonTaskRecurrenceType === 'monthly' &&
      seasonTaskMonthlyRuleType === 'nth_weekday'
        ? Number(seasonTaskMonthlyWeekday)
        : null,

    monthly_week_numbers:
      seasonTaskRecurrenceType === 'monthly' &&
      seasonTaskMonthlyRuleType === 'nth_weekday' &&
      seasonTaskMonthlyWeekNumbers.length > 0
        ? seasonTaskMonthlyWeekNumbers
        : null,

    month_of_year:
      seasonTaskRecurrenceType === 'yearly'
        ? Number(seasonTaskMonthOfYear)
        : null,

    project_id:
      seasonTaskProjectId || null,

    priority_id:
      seasonTaskPriorityId || null,

    task_time_id:
      seasonTaskTime || null,

    context_id:
      seasonTaskContextId || null,

    focus_area_id:
      seasonTaskFocusAreaId || null,

    location_id:
      seasonTaskLocationId || null,

    is_active:
      seasonTaskIsActive,

    is_pausable:
      seasonTaskIsPausable
  }

  let error

  if (editingSeasonTaskId) {
    const result = await supabase
      .from('recurring_tasks')
      .update(payload)
      .eq('id', editingSeasonTaskId)

    error = result.error
  } else {
    const result = await supabase
      .from('recurring_tasks')
      .insert([payload])

    error = result.error
  }

  if (error) {
    console.error(
      'Error saving Season task:',
      error
    )

    showToast('Could not save seasonal task')
    return
  }

  setSeasonTaskName('')
  setEditingSeasonTaskId(null)
  setSeasonTaskNotes('')
  setSeasonTaskProjectId('')
  setSeasonTaskPriorityId('')
  setSeasonTaskTime('')
  setSeasonTaskContextId('')
  setSeasonTaskFocusAreaId('')
  setSeasonTaskLocationId('')
  setSeasonTaskIsActive(true)
  setSeasonTaskIsPausable(true)

  setSeasonTaskRecurrenceType('once')
  setSeasonTaskIntervalValue(1)
  setSeasonTaskDaysOfWeek([])
  setSeasonTaskDayOfMonth('')
  setSeasonTaskMonthlyRuleType('day_of_month')
  setSeasonTaskMonthlyWeekday('')
  setSeasonTaskMonthlyWeekNumbers([])
  setSeasonTaskMonthOfYear('')

  /*
   * Keep legacy state reset for now.
   * We are migrating away from this field, but old
   * records still use it.
   */
  setSeasonalFrequencyLocal('once')

  await fetchRecurringTasks()

  showToast(
    editingSeasonTaskId
      ? 'Season task updated'
      : 'Season task added'
  )

  clearSeasonTaskForm()
}

function editSeasonTask(task) {
  setEditingSeasonTaskId(task.id)

  setSeasonTaskName(task.name || '')
  setSeasonTaskNotes(task.notes || '')

  setSeasonTaskProjectId(task.project_id || '')
  setSeasonTaskPriorityId(task.priority_id || '')
  setSeasonTaskTime(task.task_time_id || '')
  setSeasonTaskContextId(task.context_id || '')
  setSeasonTaskFocusAreaId(task.focus_area_id || '')
  setSeasonTaskLocationId(task.location_id || '')

  setSeasonTaskIsActive(task.is_active ?? true)
  setSeasonTaskIsPausable(task.is_pausable ?? true)

  /*
   * Recurrence
   *
   * Season tasks now use the same four cadence types
   * as the main recurrence engine.
   *
   * A null recurrence_type_id means Once.
   */
  const recurrenceTypeMap = {
    1: 'daily',
    2: 'weekly',
    3: 'monthly',
    4: 'yearly'
  }

  const recurrenceType =
    recurrenceTypeMap[Number(task.recurrence_type_id)] || 'once'

  setSeasonTaskRecurrenceType(recurrenceType)

  setSeasonTaskIntervalValue(
    Number(task.interval_value) || 1
  )

  setSeasonTaskDaysOfWeek(
    Array.isArray(task.days_of_week)
      ? task.days_of_week
      : []
  )

  setSeasonTaskDayOfMonth(
    task.day_of_month != null
      ? String(task.day_of_month)
      : ''
  )

  setSeasonTaskMonthlyRuleType(
    task.monthly_rule_type || 'day_of_month'
  )

  setSeasonTaskMonthlyWeekday(
    task.monthly_weekday != null
      ? String(task.monthly_weekday)
      : ''
  )

  setSeasonTaskMonthlyWeekNumbers(
    Array.isArray(task.monthly_week_numbers)
      ? task.monthly_week_numbers
      : []
  )

  setSeasonTaskMonthOfYear(
    task.month_of_year != null
      ? String(task.month_of_year)
      : ''
  )

  /*
   * Legacy field retained only so older records
   * do not leave stale UI state behind.
   */
  setSeasonalFrequencyLocal(
    task.seasonal_frequency || 'once'
  )
}

async function deleteSeasonTask(taskId) {
  const { error } = await supabase
    .from('recurring_tasks')
    .delete()
    .eq('id', taskId)

  if (error) {
    showToast('Could not delete seasonal task')
    return
  }

  fetchRecurringTasks()
  showToast('Seasonal task deleted')
}

function clearSeasonForm() {
  setEditingSeasonId(null)
  setSeasonName('')
  setSeasonNotes('')
  setSeasonStartMonth('')
  setSeasonStartDay('')
  setSeasonEndMonth('')
  setSeasonEndDay('')
  setSeasonIsActive(true)
}

function clearSeasonTaskForm() {
  setEditingSeasonTaskId(null)

  setSeasonTaskName('')
  setSeasonTaskNotes('')

  setSeasonTaskProjectId('')
  setSeasonTaskTime('')
  setSeasonTaskPriorityId('')
  setSeasonTaskContextId('')
  setSeasonTaskFocusAreaId('')
  setSeasonTaskLocationId('')

  setSeasonTaskIsActive(true)
  setSeasonTaskIsPausable(true)

  setSeasonTaskRecurrenceType('once')
  setSeasonTaskIntervalValue(1)
  setSeasonTaskDaysOfWeek([])
  setSeasonTaskDayOfMonth('')
  setSeasonTaskMonthlyRuleType('day_of_month')
  setSeasonTaskMonthlyWeekday('')
  setSeasonTaskMonthlyWeekNumbers([])
  setSeasonTaskMonthOfYear('')

  setSeasonalFrequencyLocal('once')
}

function getSeasonEmoji(name) {
  const season = name.toLowerCase()

  if (season.includes('spring')) return '🌱'
  if (season.includes('summer')) return '☀️'
  if (season.includes('fall')) return '🍂'
  if (season.includes('autumn')) return '🍂'
  if (season.includes('winter')) return '❄️'
  if (season.includes('garden')) return '🌿'

  return '📅'
}

function getCurrentSeasons() {
  const today = new Date()
  const currentMonth = today.getMonth() + 1
  const currentDay = today.getDate()

  const todayValue = currentMonth * 100 + currentDay

  return seasons.filter(season => {
    const startValue =
      Number(season.start_month) * 100 + Number(season.start_day)

    const endValue =
      Number(season.end_month) * 100 + Number(season.end_day)

    if (startValue <= endValue) {
      return todayValue >= startValue && todayValue <= endValue
    } else {
      return todayValue >= startValue || todayValue <= endValue
    }
  })
}

async function fetchProfiles() {

  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .order('bluprint_id', { ascending: true })

  if (error) {
    console.error('FETCH PROFILES FAILED:', error)
    return []
  }

  if (!data) {
    return []
  }

  setProfiles(data)

  return data
}

async function restoreActiveProfile() {

  if (!authenticatedUser) {
    console.log(
      'RESTORE ACTIVE PROFILE: waiting for authenticated user'
    )
    return
  }

  const data = await fetchProfiles()

  if (!data || data.length === 0) {
    console.error(
      'RESTORE ACTIVE PROFILE: no profiles available'
    )
    return
  }

  const canSwitchProfiles =
    authenticatedUser.is_admin === true

  const savedId =
    localStorage.getItem('bluprintUserId')

  const savedUser = data.find(
    profile => profile.id === savedId
  )

  // --------------------------------------------------
  // Restore the saved ACTIVE profile
  // --------------------------------------------------

  if (savedUser) {

    const isOwnProfile =
      savedUser.id === authenticatedUser.id

    if (isOwnProfile || canSwitchProfiles) {

      console.log(
        'RESTORING SAVED ACTIVE BLUPRINT USER:',
        savedUser.id,
        savedUser.email
      )

      switchUser(savedUser)

      return
    }
  }

  // --------------------------------------------------
  // No valid saved active profile.
  // Start with the actual authenticated profile.
  // --------------------------------------------------

  const authenticatedProfile = data.find(
    profile => profile.id === authenticatedUser.id
  )

  if (authenticatedProfile) {

    console.log(
      'USING AUTHENTICATED BLUPRINT USER:',
      authenticatedProfile.id,
      authenticatedProfile.email
    )

    switchUser(authenticatedProfile)

    return
  }

  // --------------------------------------------------
  // No matching authenticated profile.
  // --------------------------------------------------

  console.error(
    'AUTHENTICATED PROFILE NOT FOUND:',
    authenticatedUser.id,
    authenticatedUser.email
  )
}

function toggleLocationGroup(groupName) {
  setOpenLocationGroups(prev => ({
    ...prev,
    [groupName]: !prev[groupName]
  }))
}

const loadUserPreferences = async () => {
  if (!currentUser) return

  try {
    const data = await fetchUserPreferences(currentUser.id)

    setPreferences(data)

    setFocusCount(data.default_focus_count)
    setPausedMode(data.pause_mode)
    setDefaultFocusAreaId(data.default_focus_area_id)
    setDefaultDailyFlowId(data.default_daily_flow_id)
    setDefaultDayTypeId(data.default_day_type_id)

  } catch (error) {
    console.error('Error loading user preferences:', error)
  }
}


{/*RETURN CODE*/}
if (loading) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontSize: "20px"
      }}
    >
      Loading...
    </div>
  )
}
  
if (!currentUser) {
  return (
    <div className="auth-screen">
      <div className="page-card" style={{ maxWidth: '500px', margin: '80px auto' }}>
        <h2>Welcome Back</h2>

        <input
          placeholder="Email"
          value={loginEmail}
          onChange={(e) => setLoginEmail(e.target.value)}
        />

        <input
          type="password"
          placeholder="Password"
          value={loginPassword}
          onChange={(e) => setLoginPassword(e.target.value)}
        />

        <button
        type="button"
        onClick={handleLogin}
        >
          Sign In
        </button>

        <button
          onClick={() => setPage('signup')}
          style={{ marginTop: '10px' }}
        >
          Create Account
        </button>
      </div>
    </div>
  )
}

return(
  <div className="app-shell">
    {toast && <div className="toast">{toast}</div>}

    <div className="topbar">
      <div className="topbar-left">
        <img src={logo} alt="BluPrint Logo" className="topbar-logo" />
        <div className="topbar-title">BluPrint: Steady by Design</div>

        <div className="universal-filters">
          {universalFilters.map((filter) => (
            <button
              key={filter.id}
              className={
                activeUniversalFilter?.id === filter.id
                  ? 'universal-filter-button active'
                  : 'universal-filter-button'
              }
              onClick={() => toggleUniversalFilter(filter)}
            >
              {activeUniversalFilter?.id === filter.id ? '✓ ' : ''}
              {filter.name}
            </button>
          ))}
        </div>
      </div>

      <button
        className="hamburger"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
      >
        ☰
      </button>
    </div>

    <div className="layout">
          {mobileMenuOpen && (
            <div
              className="mobile-overlay"
              onClick={() => setMobileMenuOpen(false)}
            />
          )}

      <aside className={`sidebar ${mobileMenuOpen ? 'open' : ''}`}>
        <img src={logo} alt="BluPrint Logo" className="sidebar-logo" />
        
        {/*
        <button onClick={runRecurringTasksNow}>
          Run Recurring Engine
        </button>
        */}

        <button className={page === 'tasks' ? 'active-nav' : ''}
          onClick={() => {setPage('tasks');
            setMobileMenuOpen(false);}}
          >
          Tasks
        </button>
        
        
        <button
          className={page === 'capture' ? 'active-nav' : ''}
          onClick={() => {
            setPage('capture');
            setMobileMenuOpen(false);
          }}
        >
          Quick Capture
        </button>

        <button
          className={page === 'clarify' ? 'active-nav' : ''}
          onClick={() => {
            setPage('clarify');
            setMobileMenuOpen(false);
          }}
        >
          Clarify
        </button>
      

        <button className={page === 'recurring' ? 'active-nav' : ''}
          onClick={() => {setPage('recurring');
            setMobileMenuOpen(false);
          }}
        >
          Recurring
        </button>
        <button className={page === 'focus' ? 'active-nav' : ''}
          onClick={() => {setPage('focus');
            setMobileMenuOpen(false);
          }}
        >
          Focus
        </button>
        <button
          className={page === 'projects' ? 'active-nav' : ''}
          onClick={() => {setPage('projects');
            setMobileMenuOpen(false);
          }}
        >
          Projects
        </button>

        <button
          className={page === 'planning' ? 'active-nav' : ''}
          onClick={() => {
            setPage('planning')
            setMobileMenuOpen(false)
          }}
        >
          Planning
        </button>
        <button
          className={page === 'seasons' ? 'active-nav' : ''}
          onClick={() => {setPage('seasons');
            setMobileMenuOpen(false);
          }}
        >
          Seasons
        </button>
        <button className={page === 'dashboard' ? 'active-nav' : ''}
          onClick={() => {setPage('dashboard');
            setMobileMenuOpen(false);
          }}
        >
          Dashboard
        </button>

        <button className={page === 'reportProblem' ? 'active-nav' : ''}
          onClick={() => {setPage('reportProblem');
            setMobileMenuOpen(false);
          }}
        >
          Report a Problem
        </button>

        {authenticatedUser?.is_admin && (
          <button
            className={page === 'shopping' ? 'active-nav' : ''}
            onClick={() => {setPage('shopping');
              setMobileMenuOpen(false);
            }}
          >
            Shopping List
          </button>
          )}

        <button className={page === 'settings' ? 'active-nav' : ''}
          onClick={() => {setPage('settings');
            setMobileMenuOpen(false);
          }}
        >
          Settings
        </button>


        {authenticatedUser?.is_admin && (
          <button
            className={page === 'admin' ? 'active-nav' : ''}
            onClick={() => {setPage('admin');
              setMobileMenuOpen(false);
            }}
          >
            Admin
          </button>
        )}

          {authenticatedUser?.is_admin && (
          <button
            className={page === 'signup' ? 'active-nav' : ''}
            onClick={() => {setPage('signup');
              setMobileMenuOpen(false);
            }}
          >
            Signup
          </button>
        )}
      </aside>

      <main className="container">

    {toast && <div className="toast">{toast}</div>}



{/*ONBOARDING PAGE*/}
{page === 'onboarding' && (
  <div className="page-card">

    <h2>Welcome to BluPrint</h2>
    <p>Let’s build your calm command center.</p>

    <hr />

    <div
      style={{
        display: 'grid',
        gridTemplateColumns:
          window.innerWidth > 1200
            ? '1.25fr 0.9fr 0.9fr 1fr'
            : window.innerWidth > 800
            ? '1fr 1fr'
            : '1fr',
        gap: '14px',
        alignItems: 'start'
      }}
    >

      {/* COLUMN 1 */}
      <div>
    <h3>Choose Locations</h3>
    <h4 className="helper-text">Tell BluPrint where tasks happen so we can help you focus faster</h4>

{Object.entries(
  locationTemplates.reduce((groups, item) => {
    const group = item.group_name || 'Other'
    if (!groups[group]) groups[group] = []
    groups[group].push(item)
    return groups
  }, {})
).map(([groupName, items]) => (
  <div key={groupName} className="page-card" style={{ marginBottom: '12px', padding: '12px' }}>
    
    <div
      onClick={() => toggleLocationGroup(groupName)}
      style={{
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: '18px',
        display: 'flex',
        justifyContent: 'space-between'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span>{groupName}</span>
        <span style={{
          fontSize: '13px',
          opacity: 0.7,
          background: '#eef3ff',
          padding: '2px 8px',
          borderRadius: '12px'
        }}>
          {
            selectedLocations.filter(id =>
              items.some(item => item.id === id)
            ).length
          }
          /
          {items.length}
        </span>
      </div>

      <span>{openLocationGroups[groupName] ? '▾' : '▸'}</span>
    </div>

    {openLocationGroups[groupName] && (
      <div style={{ marginTop: '10px' }}>

        <div style={{
          display: 'flex',
          gap: '8px',
          marginBottom: '10px'
        }}>
          <button
            type="button"
            onClick={() => {
              const ids = items.map(i => i.id)
              setSelectedLocations(prev => [
                ...new Set([...prev, ...ids])
              ])
            }}
          >
            Select All
          </button>

          <button
            type="button"
            onClick={() => {
              const ids = items.map(i => i.id)
              setSelectedLocations(prev =>
                prev.filter(id => !ids.includes(id))
              )
            }}
          >
            Clear
          </button>
        </div>
        {items
          .slice()
          .sort((a, b) => a.name.localeCompare(b.name))
          .map(location => (
          <label
            key={location.id}
            style={{
              display: 'block',
              marginBottom: '6px'
            }}
          >
            <input
              type="checkbox"
              checked={selectedLocations.includes(location.id)}
              onChange={(e) => {
                if (e.target.checked) {
                  setSelectedLocations([...selectedLocations, location.id])

                  setOpenLocationGroups(prev => ({
                    ...prev,
                    [groupName]: true
                  }))
                } else {
                  setSelectedLocations(
                    selectedLocations.filter(id => id !== location.id)
                  )
                }
              }}
            />
            {' '}
            {location.name}
          </label>
        ))}
      </div>
    )}
  </div>
))}

    <input
      placeholder="Add custom location"
      value={customLocation}
      onChange={(e) => setCustomLocation(e.target.value)}
    />
    <button type="button" onClick={addCustomLocation}>
    Add
  </button>

    <hr />

    </div>

  {/* COLUMN 2 */}
  <div>
    <h3>Choose Contexts</h3>
    <h4 className="helper-text">Contexts help match tasks to your current tools, energy, or situation.</h4>
    {contextTemplates.map(item => (
      <label key={item.id} style={{ display: 'block' }}>
        <input
          type="checkbox"
          checked={selectedContexts.includes(item.name)}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedContexts([...selectedContexts, item.name])
            } else {
              setSelectedContexts(
                selectedContexts.filter(x => x !== item.name)
              )
            }
          }}
        />
        {' '}{item.name}
      </label>
    ))}

   <input
  placeholder="Add custom context"
  value={customContext}
  onChange={(e) => setCustomContext(e.target.value)}
  onKeyDown={(e) => {
    if (e.key === 'Enter') addCustomContext()
  }}
/>
<button type="button" onClick={addCustomContext}>
  Add
</button>

    <hr />

          </div>

      {/* COLUMN 3 */}
      <div>

    <h3>Choose Focus Areas</h3>
    <h4 className="helper-text">Focus Areas oranize life priorities like Health, Family, Work, and Growth</h4>
    {focusTemplates.map(item => (
      <label key={item.id} style={{ display: 'block' }}>
        <input
          type="checkbox"
          checked={selectedFocus.includes(item.name)}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedFocus([...selectedFocus, item.name])
            } else {
              setSelectedFocus(
                selectedFocus.filter(x => x !== item.name)
              )
            }
          }}
        />
        {' '}{item.name}
      </label>
    ))}

    <input
  placeholder="Add custom focus area"
  value={customFocus}
  onChange={(e) => setCustomFocus(e.target.value)}
  onKeyDown={(e) => {
    if (e.key === 'Enter') addCustomFocus()
  }}
/>
<button type="button" onClick={addCustomFocus}>
  Add
</button>

    <hr />
</div>

    {/* COLUMN 4 */}
        <div>
          <h3>Choose Starter Routines</h3>

          <h4 className="helper-text">
            Start with helpful routines already built for you.
          </h4>

          {recurringTemplates.map(item => (
            <label
              key={item.id}
              style={{ display: 'block', marginBottom: '8px' }}
            >
              <input
                type="checkbox"
                checked={selectedRecurring.includes(item.id)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedRecurring([
                      ...selectedRecurring,
                      item.id
                    ])
                  } else {
                    setSelectedRecurring(
                      selectedRecurring.filter(
                        x => x !== item.id
                      )
                    )
                  }
                }}
              />
              {' '}{item.name}
            </label>
          ))}
        <div className="helper-text">
            You can create custom recurring tasks anytime later from the Recurring page.
          </div>

      <div className="setup-summary">
      <div>{selectedLocations.length} Locations Selected</div>
      <div>{selectedContexts.length} Contexts Selected</div>
      <div>{selectedFocus.length} Focus Areas Selected</div>
      <div>{selectedRecurring.length} Starter Routines Selected</div>

      <button onClick={completeOnboarding}>
        Finish Setup
      </button>
    </div>
</div>
      </div>
    </div>
)}

{/*TASKS PAGE*/}
    {page === 'tasks' && (
  <>

    <div className="header">
  <div>
    <h2 style={{ color: editingTaskId ? '#d97706' : '#174ea6' }}>
  {editingTaskId
    ? `Editing: ${newTask}`
    : "Today's Options"}
</h2>
  </div>
</div>

{/* Task Form */}
<TaskForm
  newTask={newTask}
  setNewTask={setNewTask}
  dueDate={dueDate}
  setDueDate={setDueDate}
  taskTime={taskTime}
  setTaskTime={setTaskTime}
  statusId={statusId}
  setStatusId={setStatusId}
  projectId={projectId}
  setProjectId={setProjectId}
  priorityId={priorityId}
  setPriorityId={setPriorityId}
  contextId={contextId}
  setContextId={setContextId}
  focusAreaId={focusAreaId}
  setFocusAreaId={setFocusAreaId}
  locationId={locationId}
  setLocationId={setLocationId}
  notes={notes}
  setNotes={setNotes}
  timeOfDayId={timeOfDayId}
  setTimeOfDayId={setTimeOfDayId}
  impactId={impactId}
  setImpactId={setImpactId}
  capacityId={capacityId}
  setCapacityId={setCapacityId}
  dayTypeId={dayTypeId}
  setDayTypeId={setDayTypeId}
  taskTimes={taskTimes}
  statusLevels={statusLevels}
  projects={projects}
  priorityLevels={priorityLevels}
  contexts={contexts}
  focusAreas={focusAreas}
  locations={locations}
  timeOfDayLevels={timeOfDayLevels}
  impactLevels={impactLevels}
  capacityLevels={capacityLevels}
  dayTypeLevels={dayTypeLevels}
  editingTaskId={editingTaskId}
  addTask={addTask}
  saveTaskEdits={saveTaskEdits}
  resetTaskForm={resetTaskForm}
/>


{/*Paused Mode*/}
{pausedMode && (
  <div
    style={{
      background: '#fff3cd',
      color: '#856404',
      padding: '12px 16px',
      borderRadius: '10px',
      marginBottom: '16px',
      fontWeight: '600',
      border: '1px solid #ffe69c'
    }}
  >
    ⏸ Paused Mode Active — pausable recurring tasks will not generate.
  </div>
)}

{/*Views and Status*/}
<hr style={{ margin: '20px 0', opacity: 0.8 }} />

<div style={{ fontWeight: '600', marginBottom: '8px', color: '#555' }}>
  Views
</div>

<div style={{ marginBottom: '14px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
  <button onClick={() => setSmartView('all')}>All Tasks</button>
  <button onClick={() => setSmartView('today')}>Today</button>
  <button
    className={smartView === 'anytime' ? 'active-filter' : ''}
    onClick={() => setSmartView('anytime')}
  >
    Anytime
  </button>
  <button onClick={() => setSmartView('review')}>Needs Review</button>
  <button onClick={() => setSmartView('quick')}>Quick Wins</button>
  <button onClick={() => setSmartView('focus')}>Focus Mode</button>
</div>

<div style={{ fontWeight: '600', marginBottom: '8px', color: '#555' }}>
  Status
</div>

<div style={{ marginBottom: '20px', display: 'flex', gap: '10px' }}>
  <button onClick={() => setStatusFilter('active')}>
    Active
  </button>

  <button onClick={() => setStatusFilter('nextup')} style={{ marginLeft: '5px' }}>
    Next Up
  </button>

  <button onClick={() => setStatusFilter('later')} style={{ marginLeft: '5px' }}>
    Later
  </button>

  <button onClick={() => setStatusFilter('waiting')} style={{ marginLeft: '5px' }}>
    Waiting For
  </button>

  <button onClick={() => setStatusFilter('monitor')} style={{ marginLeft: '5px' }}>
    Monitor
  </button>

  <button onClick={() => setStatusFilter('completed')} style={{ marginLeft: '5px' }}>
    Completed
  </button>

  <button onClick={() => setStatusFilter('all')} style={{ marginLeft: '5px' }}>
    All
  </button>
</div>

<div style={{ marginBottom: '20px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>

  <input
    type="text"
    placeholder="Search tasks..."
    value={searchText}
    onChange={(e) => setSearchText(e.target.value)}
    style={{
      padding: '8px',
      minWidth: '220px',
      borderRadius: '8px',
      border: '1px solid #ccc'
    }}
  />

  <select
    value={focusFilter}
    onChange={(e) => setFocusFilter(e.target.value)}
    style={{
      padding: '8px',
      borderRadius: '8px'
    }}
  >
    <option value="all">All Focus Areas</option>

    {focusAreas
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(area => (
        <option key={area.id} value={area.id}>
          {area.name}
        </option>
      ))}
  </select>

      <select
          value={taskFilterProject}
          onChange={(e) => setTaskFilterProject(e.target.value)}
      >
          <option value="">All Projects</option>

          {projects
            .slice()
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(project => (
              <option
                  key={project.id}
                  value={project.id}
              >
                  {project.name}
              </option>
          ))}
      </select>

      <select
        value={sortBy}
        onChange={(e) => setSortBy(e.target.value)}
        style={{
          padding: '8px',
          borderRadius: '8px'
        }}
      >
        <option value="az">A → Z</option>
        <option value="za">Z → A</option>
        <option value="timeOfDay">Daily Flow</option>
        <option value="newest">Newest</option>
        <option value="oldest">Oldest</option>
      </select>
</div>

<hr style={{ margin: '20px 0', opacity: 0.8 }} />

<div id="today-section">

    {filteredTasks.map(task => (
      
  <div key={task.id} className="task-row">

    <input
      type="checkbox"
      checked={task.is_completed}
      onChange={() => toggleTask(task)}
    />

    <div
      className="task-main"
      style={{
        textDecoration: task.is_completed ? 'line-through' : 'none',
        color: task.is_completed ? '#999' : '#000'
      }}
    >
      <div>
        
          {task.name}

        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginTop: '4px' }}>

          {task.timeOfDay?.name && (
            <span className="task-badge">{task.timeOfDay.name}</span>
          )}

          {task.impact?.name && (
            <span className="task-badge">{task.impact.name}</span>
          )}

          {task.capacity?.name && (
            <span className="task-badge">{task.capacity.name}</span>
          )}

          {task.dayType?.name && (
            <span className="task-badge">{task.dayType.name}</span>
          )}

        </div>

        {task.duration && (
          <span style={{ marginLeft: '8px', color: '#888' }}>
            • {task.duration.name}
          </span>
        )}

        <StatusBadge status={task.status?.name} />
        <ReviewStatusBadge reviewStatus={task.review_status} />

        {task.priority && (
  <span
    style={{
      marginLeft: '8px',
      padding: '2px 8px',
      borderRadius: '12px',
      fontSize: '12px',
      background:
        task.priority.name === 'Essential'
          ? '#dbeafe'
          : task.priority.name === 'Momentum'
          ? '#fed7aa'
          : task.priority.name === 'Flexible'
          ? '#e5e7eb'
          : '#ede9fe',
      color: '#222'
    }}
  >
    {task.priority.name}
  </span>
)}

{task.project?.name && (
  <span
    style={{
      marginLeft: '8px',
      padding: '2px 8px',
      borderRadius: '12px',
      fontSize: '12px',
      background: '#eef2ff',
      color: '#4338ca'
    }}
  >
    📁 {task.project.name}
  </span>
)}

        {getTaskTypeName(task.task_type_id) && (
          <span style={{ marginLeft: '8px', color: '#aaa' }}>
            ({getTaskTypeName(task.task_type_id)})
          </span>
        )}
      </div>

      {task.due_date && (
        <div className="task-meta">
          📅 {(() => {
            const [y, m, d] = task.due_date.split('T')[0].split('-')
            return `${Number(m)}/${Number(d)}/${y}`
          })()}
        </div>
      )}

      {task.notes && (
        <div
          style={{
            fontSize: '13px',
            color: '#555',
            marginTop: '4px',
            fontStyle: 'italic'
          }}
        >
          📝 {task.notes}
        </div>
      )}
    </div>

    <div className="task-actions">

      <EditButton
        onClick={() => startEdit(task)}
      />

      <SkipButton
        onClick={() => skipTask(task)}
      />
       
       
      <DeleteButton
        onClick={() => deleteTask(task.id)}
      />    
    
    </div>
  </div>
))}
    </div>
    </>
)}

{/*Add Task Page*/}

{page === 'add' && (
<>
  <div className="header">
    <div>
      <h2 style={{ margin: 0, color: '#0047AB' }}>Add Task</h2>
      <div className="tagline">Create a new task</div>
    </div>
  </div>

  <hr />

  <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '12px' }}>
    <input
      type="text"
      placeholder="New task..."
      value={newTask}
      onChange={(e) => setNewTask(e.target.value)}
    />

    <input
      type="date"
      value={dueDate}
      onChange={(e) => setDueDate(e.target.value)}
    />

    <select value={taskTime} onChange={(e) => setTaskTime(e.target.value)}>
      <option value="">Time</option>
      {taskTimes.map(t => (
        <option key={t.id} value={t.id}>{t.name}</option>
      ))}
    </select>

    <select value={priorityId} onChange={(e) => setPriorityId(e.target.value)}>
      <option value="">Consistency Value</option>
      {priorityLevels.map(p => (
        <option key={p.id} value={p.id}>{p.name}</option>
      ))}
    </select>

    <select value={statusId} onChange={(e) => setStatusId(e.target.value)}>
      <option value="">Status</option>
      {statusLevels.map(s => (
        <option key={s.id} value={s.id}>{s.name}</option>
      ))}
    </select>

    <select
      value={projectId}
      onChange={(e) => setProjectId(e.target.value)}
    >
      <option value="">Project</option>

      {projects.map(project => (
        <option key={project.id} value={project.id}>
          {project.name}
        </option>
      ))}
    </select>

    <select
      value={timeOfDayId}
      onChange={(e) => setTimeOfDayId(e.target.value)}
    >
      <option value="">Time of Day</option>
      {timeOfDayLevels.map(item => (
        <option key={item.id} value={item.id}>
          {item.name}
        </option>
      ))}
    </select>

    <select
      value={impactId}
      onChange={(e) => setImpactId(e.target.value)}
    >
      <option value="">Impact</option>
      {impactLevels.map(item => (
        <option key={item.id} value={item.id}>
          {item.name}
        </option>
      ))}
    </select>

    <select
      value={capacityId}
      onChange={(e) => setCapacityId(e.target.value)}
    >
      <option value="">Capacity</option>
      {capacityLevels.map(item => (
        <option key={item.id} value={item.id}>
          {item.name}
        </option>
      ))}
    </select>

    <select
      value={dayTypeId}
      onChange={(e) => setDayTypeId(e.target.value)}
    >
      <option value="">Day Type</option>
      {dayTypeLevels.map(item => (
        <option key={item.id} value={item.id}>
          {item.name}
        </option>
      ))}
    </select>
  </div>

  <input
    value={notes}
    onChange={(e) => setNotes(e.target.value)}
    placeholder="Notes..."
    style={{ width: '100%', marginBottom: '14px' }}
  />

  <button onClick={addTask}>Add Task</button>
</>
)}

{/*QUICK CAPTURE PAGE*/}
{page === 'capture' && <QuickCapturePage user={currentUser} />}

{/*CLARIFY PAGE*/}
{page === 'clarify' && (
<ClarifyPage
  user={currentUser}
  onConvertToTask={startTaskFromInbox}
  onConvertToProject={startProjectFromInbox}
  onConvertToRecurring={startRecurringFromInbox}
/>
)}

{/*RECURRING TASK PAGE*/}
{page === 'recurring' && (

  <RecurringPage

        /* DATA */
      recurringTasks={recurringTasksList}
      filteredRecurringTasks={filteredRecurringTasks}

      /* EDITING */
      editingRecurringId={editingRecurringId}

      /* FORM */
      newRecurringTask={newRecurringTask}
      setNewRecurringTask={setNewRecurringTask}

      recurringTaskTime={recurringTaskTime}
      setRecurringTaskTime={setRecurringTaskTime}

      recurringDaysOfWeek={recurringDaysOfWeek}
      setRecurringDaysOfWeek={setRecurringDaysOfWeek}

      recurringDayOfMonth={recurringDayOfMonth}
      setRecurringDayOfMonth={setRecurringDayOfMonth}

      recurringMonthlyRuleType={recurringMonthlyRuleType}
      setRecurringMonthlyRuleType={setRecurringMonthlyRuleType}

      recurringMonthlyWeekday={recurringMonthlyWeekday}
      setRecurringMonthlyWeekday={setRecurringMonthlyWeekday}

      recurringMonthlyWeekNumbers={recurringMonthlyWeekNumbers}
      setRecurringMonthlyWeekNumbers={setRecurringMonthlyWeekNumbers}

      recurringMonthOfYear={recurringMonthOfYear}
      setRecurringMonthOfYear={setRecurringMonthOfYear}

      recurringFocusFilter={recurringFocusFilter}
      setRecurringFocusFilter={setRecurringFocusFilter}

      recurringLocationFilter={recurringLocationFilter}
      setRecurringLocationFilter={setRecurringLocationFilter}

      recurringSortBy={recurringSortBy}
      setRecurringSortBy={setRecurringSortBy}

      recurringTasksList={recurringTasksList}

      seasons={seasons}
      seasonalFrequency={seasonalFrequency}
      setSeasonalFrequency={setSeasonalFrequency}
      recurringSeasonId={recurringSeasonId}
      setRecurringSeasonId={setRecurringSeasonId}

      recurringStatusId={recurringStatusId}
      setRecurringStatusId={setRecurringStatusId}

      recurrenceAnchorType={recurrenceAnchorType}
      setRecurrenceAnchorType={setRecurrenceAnchorType}

      persistenceType={persistenceType}
      setPersistenceType={setPersistenceType}

      recurrenceType={recurrenceType}
      setRecurrenceType={setRecurrenceType}

      recurrenceTypes={recurrenceTypes}

      recurringIntervalValue={recurringIntervalValue}
      setRecurringIntervalValue={setRecurringIntervalValue}

      recurringIntervalUnit={recurringIntervalUnit}
      setRecurringIntervalUnit={setRecurringIntervalUnit}

      recurrenceStartDate={recurrenceStartDate}
      setRecurrenceStartDate={setRecurrenceStartDate}

      recurrenceEndDate={recurrenceEndDate}
      setRecurrenceEndDate={setRecurrenceEndDate}

      recurringNotes={recurringNotes}
      setRecurringNotes={setRecurringNotes}

      recurringProjectId={recurringProjectId}
      setRecurringProjectId={setRecurringProjectId}

      recurringPriorityId={recurringPriorityId}
      setRecurringPriorityId={setRecurringPriorityId}

      recurringContextId={recurringContextId}
      setRecurringContextId={setRecurringContextId}

      getRecurrenceSummary={getRecurrenceSummary}
      getSeasonName={getSeasonName}
      formatLabel={formatLabel}

      recurringFocusAreaId={recurringFocusAreaId}
      setRecurringFocusAreaId={setRecurringFocusAreaId}

      recurringLocationId={recurringLocationId}
      setRecurringLocationId={setRecurringLocationId}

      recurringTimeOfDayId={recurringTimeOfDayId}
      setRecurringTimeOfDayId={setRecurringTimeOfDayId}

      recurringImpactId={recurringImpactId}
      setRecurringImpactId={setRecurringImpactId}

      recurringCapacityId={recurringCapacityId}
      setRecurringCapacityId={setRecurringCapacityId}

      recurringDayTypeId={recurringDayTypeId}
      setRecurringDayTypeId={setRecurringDayTypeId}

      recurringIsActive={recurringIsActive}
      setRecurringIsActive={setRecurringIsActive}

      recurringIsPausable={recurringIsPausable}
      setRecurringIsPausable={setRecurringIsPausable}

      /* LOOKUPS */
      taskTimes={taskTimes}
      statusLevels={statusLevels}
      recurrenceTypes={recurrenceTypes}
      projects={projects}
      priorityLevels={priorityLevels}
      contexts={contexts}
      focusAreas={focusAreas}
      locations={locations}
      timeOfDayLevels={timeOfDayLevels}
      impactLevels={impactLevels}
      capacityLevels={capacityLevels}
      dayTypeLevels={dayTypeLevels}

      /* SEARCH */
      recurringSearch={recurringSearch}
      setRecurringSearch={setRecurringSearch}

      /* ACTIONS */
      addRecurringTask={addRecurringTask}
      updateRecurringTask={updateRecurringTemplate}

      startEditRecurring={startEditRecurring}
      deleteRecurringTask={deleteRecurringTask}

      setEditingRecurringId={setEditingRecurringId}

      formatDate={formatDate}

      operationalToday={operationalToday}

      editIcon={editIcon}
      deleteIcon={deleteIcon}

      lastReviewedAt={lastReviewedAt}
      setLastReviewedAt={setLastReviewedAt}

      resetRecurringForm={resetRecurringForm}

    />

)}

{/* FOCUS PAGE */}
{page === 'focus' && (
  <>
    <div className="header">
      <div>
        <h2 style={{ margin: 0, color: '#0047AB' }}>Focus Blocks</h2>
        <div className="tagline">Generate a clear starting plan for right now</div>
      </div>
    </div>

    <hr />

    <div style={{ marginBottom: '18px' }}>
      <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>
        Build Your Focus List
      </div>

      
        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'center' }}>

  <select
    value={focusBlockType}
    onChange={(e) => {
      setFocusBlockType(e.target.value)
      setFocusBlockValue('')
    }}
  >
    <option value="project">Project</option>
    <option value="location">Location</option>
    <option value="context">Context</option>
    <option value="focusArea">Focus Area</option>
  </select>

  {focusBlockType !== 'general' && (
    <select
      value={focusBlockValue}
      onChange={(e) => setFocusBlockValue(e.target.value)}
    >
      <option value="">Choose...</option>

      {getFocusOptions()
        .slice()
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(item => (
        <option key={item.id} value={item.id}>
          {item.name}
        </option>
      ))}
    </select>
  )}

  <input
    type="number"
    value={focusCount}
    min="1"
    max="10"
    onChange={(e) => setFocusCount(Number(e.target.value))}
    style={{ width: '80px' }}
  />

  <select
    value={focusTaskTime}
    onChange={(e) => setFocusTaskTime(e.target.value)}
  >
    <option value="">Task Time</option>

    {taskTimes.map(t => (
      <option key={t.id} value={t.id}>
        {t.name}
      </option>
    ))}
  </select>

  <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
  <button onClick={() => generateFocusBlocks(true)}>
    Generate & Start
  </button>

  <button onClick={() => generateFocusBlocks(false)}>
    Generate More
  </button>
</div>

</div>

      <div className="tagline">
      Choose how many tasks you want and what kind of momentum you need today.
    </div>
    </div>
  </>
)}

{/* PROJECTS PAGE */}
<ProjectPage
  page={page}
  selectedProject={selectedProject}
  projects={projects}

  projectName={projectName}
  setProjectName={setProjectName}
  projectFocusAreaId={projectFocusAreaId}
  setProjectFocusAreaId={setProjectFocusAreaId}
  projectStatusId={projectStatusId}
  setProjectStatusId={setProjectStatusId}
  projectNotes={projectNotes}
  setProjectNotes={setProjectNotes}

  focusAreas={focusAreas}
  statusLevels={statusLevels}

  editingProjectId={editingProjectId}
  saveProject={saveProject}
  clearProjectForm={clearProjectForm}

  startEditRecurring={startEditRecurring}

  projectSearch={projectSearch}
  setProjectSearch={setProjectSearch}
  projectFilterFocusArea={projectFilterFocusArea}
  setProjectFilterFocusArea={setProjectFilterFocusArea}
  projectFilterStatus={projectFilterStatus}
  setProjectFilterStatus={setProjectFilterStatus}

  getTasksForProject={getTasksForProject}
  getRecurringForProject={getRecurringForProject}

  openProject={openProject}
  editProject={editProject}
  deleteProject={deleteProject}

  clearProjectDetailForms={clearProjectDetailForms}
  setPage={setPage}

  showArchived={showArchived}
  setShowArchived={setShowArchived}
  archiveProject={archiveProject}
  attemptDeleteProject={attemptDeleteProject}

  projectTaskName={projectTaskName}
  setProjectTaskName={setProjectTaskName}
  projectTaskNotes={projectTaskNotes}
  setProjectTaskNotes={setProjectTaskNotes}
  saveProjectTask={saveProjectTask}
  completeTask={completeTask}

  projectRecurringName={projectRecurringName}
  setProjectRecurringName={setProjectRecurringName}
  projectRecurringNotes={projectRecurringNotes}
  setProjectRecurringNotes={setProjectRecurringNotes}
  projectRecurringFrequency={projectRecurringFrequency}
  setProjectRecurringFrequency={setProjectRecurringFrequency}
  saveProjectRecurring={saveProjectRecurring}

  recurrenceType={recurrenceType}
  recurringDaysOfWeek={recurringDaysOfWeek}
  setRecurringDaysOfWeek={setRecurringDaysOfWeek}

  startEdit={startEdit}

  editIcon={editIcon}
  deleteIcon={deleteIcon}
/>

{/* PLANNING PAGE */}
{page === 'planning' && (
  <PlanningPage
    currentUser={currentUser}
  />
)}

{/* SEASONS PAGE */}
{page === 'seasons' && (
<>
  <div className="header">
    <div>
      <h2 className="season-list-title">Seasons</h2>
      <div className="tagline">
        Manage your life rhythms and custom seasons
      </div>
    </div>
  </div>

  <hr />

    <div className="season-form-card">
  <h3 style={{ marginTop: 0 }}>
    {editingSeasonId ? 'Edit Season' : 'Add Season'}
  </h3>

  <div className="tagline" style={{ marginBottom: '14px' }}>
    Define a life rhythm, chapter, or seasonal focus
  </div>

  <div className="season-form-grid">

    <input
      placeholder="Season name"
      value={seasonName}
      onChange={(e) => setSeasonName(e.target.value)}
    />

    <select
      value={seasonStartMonth}
      onChange={(e) => setSeasonStartMonth(Number(e.target.value))}
    >
      <option value="">Start Month</option>
      {months.map(month => (
        <option key={month.value} value={month.value}>
          {month.name}
        </option>
      ))}
    </select>

    
    <input
      type="number"
      min="1"
      max="31"
      placeholder="Start Day"
      value={seasonStartDay}
      onChange={(e) => setSeasonStartDay(e.target.value)}
    />

    <select
      value={seasonEndMonth}
      onChange={(e) => setSeasonEndMonth(Number(e.target.value))}
    >
      <option value="">End Month</option>
      {months.map(month => (
        <option key={month.value} value={month.value}>
          {month.name}
        </option>
      ))}
    </select>
    
    <input
      type="number"
      min="1"
      max="31"
      placeholder="End Day"
      value={seasonEndDay}
      onChange={(e) => setSeasonEndDay(e.target.value)}
    />

    <label className="season-checkbox">
      <input
        type="checkbox"
        checked={seasonIsActive}
        onChange={(e) => setSeasonIsActive(e.target.checked)}
      />
      Active
    </label>
  </div>

  <textarea
    className="season-notes"
    placeholder="Notes, purpose, mindset, priorities..."
    value={seasonNotes}
    onChange={(e) => setSeasonNotes(e.target.value)}
  />

  <div className="season-form-actions">
    <div className="season-form-actions">
  <button onClick={addSeason}>
    {editingSeasonId ? 'Update Season' : 'Save Season'}
  </button>

  {editingSeasonId && (
    <button
      onClick={clearSeasonForm}
      style={{ background: '#666' }}
    >
      Cancel Edit
    </button>
  )}
</div>

    
  </div>
</div>

  <hr />

  <h3>Your Seasons</h3>

  {seasons.map(season => (
  <div
    key={season.id}
    onClick={() => {
      setSelectedSeason(season)
      setPage('seasonDetail')
    }}
    className="season-list-card"
  >
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '16px'
      }}
    >
      {/* LEFT SIDE */}
      <div style={{ flex: 1 }}>
        <div className="season-list-name">
          {season.name}
        </div>

        <div className="season-list-dates">
          {season.start_month}/{season.start_day} → {season.end_month}/{season.end_day}
        </div>

        <div className="season-list-meta">
  {season.is_active ? '✅ Active' : '⏸ Inactive'}
</div>

{season.notes && (
  <div style={{
    marginTop: '6px',
    fontSize: '14px',
    color: '#5b6475',
    maxWidth: '650px',
    lineHeight: '1.4'
  }}>
    {season.notes}
  </div>
)}

<div style={{
  marginTop: '6px',
  fontSize: '13px',
  color: '#666'
}}>
  📋 Used by {getSeasonTaskCount(season.id)} recurring task
  {getSeasonTaskCount(season.id) !== 1 ? 's' : ''}
</div>
      </div>

      {/* RIGHT SIDE BUTTONS */}
      <div className="task-actions">
        <button
          className={`circle-btn btn-edit ${
            editingSeasonId === season.id ? 'active' : ''
          }`}
          onClick={(e) => {
            e.stopPropagation()
            editSeason(season)
          }}
        >
          <img src={editIcon} className="icon" alt="Edit" />
        </button>

        <button
          className={`icon-button ${season.is_active ? 'pause-button' : 'activate-button'}`}
          onClick={(e) => {
            e.stopPropagation()
            toggleSeasonActive(season)
          }}
          title={season.is_active ? 'Deactivate Season' : 'Activate Season'}
        >
          {season.is_active ? '⏸️' : '▶️'}
        </button>

        <button
          className="circle-btn btn-delete"
          onClick={(e) => {
            e.stopPropagation()
            deleteSeason(season.id)
          }}
        >
          <img src={deleteIcon} className="icon" alt="Delete" />
        </button>
      </div>
    </div>
  </div>
))}
</>
)}

{/* SEASON DETAIL PAGE */}
{page === 'seasonDetail' && selectedSeason && (
  <div className="page-card">
    <div className="season-hero">
  <h2 style={{ marginTop: 0 }}>{selectedSeason.name}</h2>

  <div style={{ marginTop: '8px', color: '#475569' }}>
    {selectedSeason.start_month}/{selectedSeason.start_day}
    {' → '}
    {selectedSeason.end_month}/{selectedSeason.end_day}
  </div>

  {selectedSeason.notes && (
  <div style={{
    fontSize: '14px',
    color: '#666',
    marginTop: '6px'
  }}>
    {selectedSeason.notes}
  </div>
)}

  <div style={{ marginTop: '10px' }}>
    <span className="season-pill pill-active">
      {selectedSeason.is_active ? '✅ Active' : '⏸ Inactive'}
    </span>
  </div>

  <div style={{ marginTop: '14px' }}>
    <button onClick={() => setPage('seasons')}>
      ← Back to Seasons
    </button>
  </div>
</div>

<div style={{ marginBottom: '12px' }}>
  <h3 style={{ margin: 0, color: '#0047AB' }}>
    Manage Tasks for {selectedSeason.name}
  </h3>
  <div className="tagline">
    Create routines that run during this season
  </div>
</div>

<div style={{
  display: 'flex',
  gap: '10px',
  flexWrap: 'wrap',
  marginBottom: '12px'
}}>

  <input
    type="text"
    placeholder="Season task..."
    value={seasonTaskName}
    onChange={(e) => setSeasonTaskName(e.target.value)}
  />

  {/* SEASON TASK RECURRENCE */}

<select
  value={seasonTaskRecurrenceType}
  onChange={(e) => {
    const value = e.target.value
    setSeasonTaskRecurrenceType(value)

    // Clear schedule-specific settings when changing type.
    setSeasonTaskDaysOfWeek([])
    setSeasonTaskDayOfMonth('')
    setSeasonTaskMonthlyRuleType('day_of_month')
    setSeasonTaskMonthlyWeekday('')
    setSeasonTaskMonthlyWeekNumbers([])
    setSeasonTaskMonthOfYear('')

    if (value === 'once') {
      setSeasonTaskIntervalValue(1)
    }
  }}
>
  <option value="once">Once</option>
  <option value="daily">Daily</option>
  <option value="weekly">Weekly</option>
  <option value="monthly">Monthly</option>
  <option value="yearly">Yearly</option>
</select>

{/* INTERVAL */}

{seasonTaskRecurrenceType !== 'once' && (
  <>
    <span style={{
      display: 'flex',
      alignItems: 'center',
      gap: '6px'
    }}>
      <span>Every</span>

      <input
        type="number"
        min="1"
        value={seasonTaskIntervalValue}
        onChange={(e) =>
          setSeasonTaskIntervalValue(
            e.target.value
          )
        }
        style={{ width: '70px' }}
      />

      <span>
        {seasonTaskRecurrenceType === 'daily' && 'days'}
        {seasonTaskRecurrenceType === 'weekly' && 'weeks'}
        {seasonTaskRecurrenceType === 'monthly' && 'months'}
        {seasonTaskRecurrenceType === 'yearly' && 'years'}
      </span>
    </span>
  </>
)}

{/* WEEKLY DAYS */}

{seasonTaskRecurrenceType === 'weekly' && (
  <>
    {['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].map(
      (label, index) => (
        <label
          key={index}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '3px'
          }}
        >
          <input
            type="checkbox"
            checked={seasonTaskDaysOfWeek.includes(index)}
            onChange={(e) => {
              if (e.target.checked) {
                setSeasonTaskDaysOfWeek([
                  ...seasonTaskDaysOfWeek,
                  index
                ])
              } else {
                setSeasonTaskDaysOfWeek(
                  seasonTaskDaysOfWeek.filter(
                    day => day !== index
                  )
                )
              }
            }}
          />

          {label}
        </label>
      )
    )}
  </>
)}

{/* MONTHLY OPTIONS */}

{seasonTaskRecurrenceType === 'monthly' && (
  <>
    <select
      value={seasonTaskMonthlyRuleType}
      onChange={(e) => {
        const value = e.target.value

        setSeasonTaskMonthlyRuleType(value)

        if (value === 'day_of_month') {
          setSeasonTaskMonthlyWeekday('')
          setSeasonTaskMonthlyWeekNumbers([])
        } else {
          setSeasonTaskDayOfMonth('')
        }
      }}
    >
      <option value="day_of_month">
        Day of Month
      </option>

      <option value="nth_weekday">
        Weekday of Month
      </option>
    </select>

    {seasonTaskMonthlyRuleType === 'day_of_month' && (
      <input
        type="number"
        min="1"
        max="31"
        placeholder="Day (1–31)"
        value={seasonTaskDayOfMonth}
        onChange={(e) =>
          setSeasonTaskDayOfMonth(e.target.value)
        }
        style={{ width: '90px' }}
      />
    )}

    {seasonTaskMonthlyRuleType === 'nth_weekday' && (
      <>
        <select
          value={seasonTaskMonthlyWeekday}
          onChange={(e) =>
            setSeasonTaskMonthlyWeekday(e.target.value)
          }
        >
          <option value="">Weekday</option>
          <option value="0">Sunday</option>
          <option value="1">Monday</option>
          <option value="2">Tuesday</option>
          <option value="3">Wednesday</option>
          <option value="4">Thursday</option>
          <option value="5">Friday</option>
          <option value="6">Saturday</option>
        </select>

        <div
          style={{
            display: 'flex',
            gap: '8px',
            alignItems: 'center',
            flexWrap: 'wrap'
          }}
        >
          {[1, 2, 3, 4, 5].map(weekNumber => (
            <label
              key={weekNumber}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '3px'
              }}
            >
              <input
                type="checkbox"
                checked={seasonTaskMonthlyWeekNumbers.includes(
                  weekNumber
                )}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSeasonTaskMonthlyWeekNumbers([
                      ...seasonTaskMonthlyWeekNumbers,
                      weekNumber
                    ])
                  } else {
                    setSeasonTaskMonthlyWeekNumbers(
                      seasonTaskMonthlyWeekNumbers.filter(
                        number => number !== weekNumber
                      )
                    )
                  }
                }}
              />

              {weekNumber}
            </label>
          ))}

          <label
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '3px'
            }}
          >
            <input
              type="checkbox"
              checked={seasonTaskMonthlyWeekNumbers.includes(-1)}
              onChange={(e) => {
                if (e.target.checked) {
                  setSeasonTaskMonthlyWeekNumbers([
                    ...seasonTaskMonthlyWeekNumbers,
                    -1
                  ])
                } else {
                  setSeasonTaskMonthlyWeekNumbers(
                    seasonTaskMonthlyWeekNumbers.filter(
                      number => number !== -1
                    )
                  )
                }
              }}
            />

            Last
          </label>
        </div>
      </>
    )}
  </>
)}

{/* YEARLY OPTIONS */}

{seasonTaskRecurrenceType === 'yearly' && (
  <>
    <select
      value={seasonTaskMonthOfYear}
      onChange={(e) =>
        setSeasonTaskMonthOfYear(e.target.value)
      }
    >
      <option value="">Month</option>

      {[
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ].map((month, index) => (
        <option
          key={index + 1}
          value={index + 1}
        >
          {month}
        </option>
      ))}
    </select>

    <select
      value={seasonTaskDayOfMonth}
      onChange={(e) =>
        setSeasonTaskDayOfMonth(e.target.value)
      }
    >
      <option value="">Day</option>

      {Array.from(
        { length: 31 },
        (_, index) => index + 1
      ).map(day => (
        <option
          key={day}
          value={day}
        >
          {day}
        </option>
      ))}
    </select>
  </>
)}

  <input
    value={seasonTaskNotes}
    onChange={(e) => setSeasonTaskNotes(e.target.value)}
    placeholder="Notes..."
    style={{ width: '100%' }}
  />

  <select value={seasonTaskProjectId} onChange={(e) => setSeasonTaskProjectId(e.target.value)}>
    <option value="">Project</option>
    {projects.map(project => (
      <option key={project.id} value={project.id}>{project.name}</option>
    ))}
  </select>

  <select value={seasonTaskTime} onChange={(e) => setSeasonTaskTime(e.target.value)}>
    <option value="">Task Time</option>
    {taskTimes.map(t => (
      <option key={t.id} value={t.id}>{t.name}</option>
    ))}
  </select>

  <select value={seasonTaskPriorityId} onChange={(e) => setSeasonTaskPriorityId(e.target.value)}>
    <option value="">Consistency Value</option>
    {priorityLevels.map(p => (
      <option key={p.id} value={p.id}>{p.name}</option>
    ))}
  </select>

  <select value={seasonTaskContextId} onChange={(e) => setSeasonTaskContextId(e.target.value)}>
    <option value="">Context</option>
    {contexts.map(c => (
      <option key={c.id} value={c.id}>{c.name}</option>
    ))}
  </select>

  <select value={seasonTaskFocusAreaId} onChange={(e) => setSeasonTaskFocusAreaId(e.target.value)}>
    <option value="">Focus Area</option>
    {focusAreas.map(f => (
      <option key={f.id} value={f.id}>{f.name}</option>
    ))}
  </select>

  <select value={seasonTaskLocationId} onChange={(e) => setSeasonTaskLocationId(e.target.value)}>
    <option value="">Location</option>
    {locations.map(l => (
      <option key={l.id} value={l.id}>{l.name}</option>
    ))}
  </select>

  <label style={{ display:'flex', alignItems:'center', gap:'6px' }}>
    <input
      type="checkbox"
      checked={seasonTaskIsActive}
      onChange={(e) => setSeasonTaskIsActive(e.target.checked)}
    />
    Active
  </label>

  <label style={{ display:'flex', alignItems:'center', gap:'6px' }}>
    <input
      type="checkbox"
      checked={seasonTaskIsPausable}
      onChange={(e) => setSeasonTaskIsPausable(e.target.checked)}
    />
    Pausable
  </label>

  <button onClick={saveSeasonTask}>
    {editingSeasonTaskId ? 'Save Changes' : 'Add Seasonal Task'}
  </button>

  {editingSeasonTaskId && (
  <button
    onClick={clearSeasonTaskForm}
    style={{ background:'#64748b' }}
  >
    Cancel Edit
  </button>
)}
</div>

<h3 className="section-title">Tasks in this Season</h3>

{getTasksForSeason(selectedSeason.id).length === 0 ? (
  <div className="empty-state">
    🌱 No seasonal tasks yet.<br />
    Add one above to get started.
  </div>
) : (
  getTasksForSeason(selectedSeason.id).map(task => (
    <div key={task.id} className="season-task-card">

      <div style={{
        display:'flex',
        justifyContent:'space-between',
        gap:'12px',
        alignItems:'flex-start'
      }}>

        <div style={{ flex:1 }}>
          <div style={{ fontWeight:700, fontSize:'18px' }}>
            {task.name}
          </div>

          {task.notes && (
            <div style={{
              marginTop:'4px',
              color:'#666',
              fontSize:'14px'
            }}>
              {task.notes}
            </div>
          )}

          <div style={{
            display:'flex',
            flexWrap:'wrap',
            gap:'6px',
            marginTop:'10px'
          }}>

            <span className="season-pill pill-frequency">
              🔁 {
                task.recurrence_type_id == null
                  ? 'Once per season'
                  : task.recurrence_type_id === 1
                    ? `Every ${task.interval_value || 1} day${(task.interval_value || 1) === 1 ? '' : 's'}`
                    : task.recurrence_type_id === 2
                      ? `Every ${task.interval_value || 1} week${(task.interval_value || 1) === 1 ? '' : 's'}`
                      : task.recurrence_type_id === 3
                        ? `Every ${task.interval_value || 1} month${(task.interval_value || 1) === 1 ? '' : 's'}`
                        : task.recurrence_type_id === 4
                          ? `Every ${task.interval_value || 1} year${(task.interval_value || 1) === 1 ? '' : 's'}`
                          : 'Recurrence not configured'
              }
            </span>

            {task.priority?.name && (
              <span className="season-pill pill-priority">
                ⭐ {task.priority.name}
              </span>
            )}

            {task.project?.name && (
              <span className="season-pill pill-project">
                📁 {task.project.name}
              </span>
            )}

            {task.context?.name && (
              <span className="season-pill pill-context">
                🧭 {task.context.name}
              </span>
            )}

            {task.focus_area?.name && (
              <span className="season-pill pill-focus">
                🎯 {task.focus_area.name}
              </span>
            )}

            {task.location?.name && (
              <span className="season-pill pill-location">
                📍 {task.location.name}
              </span>
            )}

            {task.is_active && (
              <span className="season-pill pill-active">
                ✅ Active
              </span>
            )}

            {task.is_pausable && (
              <span className="season-pill pill-pause">
                ⏸ Pausable
              </span>
            )}

          </div>
        </div>

        <div className="task-actions">
  <button
    className="circle-btn btn-edit"
    onClick={() => editSeasonTask(task)}
    title="Edit Task"
  >
    <img src={editIcon} className="icon" alt="Edit" />
  </button>

  <button
    className="circle-btn btn-delete"
    onClick={() => deleteSeasonTask(task.id)}
    title="Delete Task"
  >
    <img src={deleteIcon} className="icon" alt="Delete" />
  </button>
</div>

      </div>
    </div>
  ))
)}
</div>
)}

{/*REPORT A PROBLEM PAGE*/}
{page === 'reportProblem' && <BugReportPage user={currentUser} />}

{/* DASHBOARD PAGE */}
{page === 'dashboard' && (
  <>
    <div className="header">
      <div>
        <h2 style={{ margin: 0, color: '#0047AB' }}>Today Dashboard</h2>
        <div className="tagline">Your calm command center</div>
      </div>
    </div>

    <hr />

    <div className="stats">
      <div>✅ Completed Today: {completedToday}</div>
      <div>📊 Total Completed: {totalCompleted}</div>
      <div>📋 Open Tasks: {filteredTasks.length}</div>
    </div>

    <hr />

   {getCurrentSeasons().length > 0 && (
  <div className="page-card" style={{ marginBottom: '18px' }}>
    <h3 style={{ marginTop: 0 }}>Current Season</h3>

    <div style={{
      display: 'grid',
      gap: '14px'
    }}>
      {getCurrentSeasons().map(season => (
        <div
          key={season.id}
          style={{
            paddingBottom: '14px',
            borderBottom: '1px solid #e5e7eb'
          }}
        >
          <div style={{
            fontSize: '24px',
            fontWeight: 700,
            color: '#0047AB'
          }}>
            {getSeasonEmoji(season.name)} {season.name}
          </div>

          <div style={{
            marginTop: '6px',
            color: '#666'
          }}>
            {season.start_month}/{season.start_day}
            {' → '}
            {season.end_month}/{season.end_day}
          </div>

          {season.notes && (
            <div style={{
              marginTop: '10px',
              color: '#4b5563',
              lineHeight: '1.5'
            }}>
              {season.notes}
            </div>
          )}

          <div style={{ marginTop: '10px' }}>
            📋 {getSeasonTaskCount(season.id)} recurring task
            {getSeasonTaskCount(season.id) !== 1 ? 's' : ''}
          </div>
        </div>
      ))}
    </div>
  </div>
)}

    <div style={{ marginBottom: '20px' }}>
      <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>
        Start Here
      </div>

      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
        <button onClick={() => setPage('add')}>+ Add Task</button>
        <button onClick={() => setPage('focus')}>⚡ Focus Blocks</button>
        <button
  onClick={() => {
      generateRecurringTasks()
  }}
>
  ▶ Start Today
</button>
      </div>
    </div>

    <hr />

    <div>
      <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>
        Best Next Steps
      </div>

      {filteredTasks.slice(0, 3).map(task => (
        <div key={task.id} className="task-row">
          <div className="task-main">{task.name}</div>
        </div>
      ))}
    </div>
  </>
)}


{/* SHOPPING PAGE */}
{page === 'shopping' && (
  <ShoppingPage currentUser={currentUser} />
)}



{/*SETTINGS PAGE*/}
{page === 'settings' && (
  <>
    <div className="header">
      <div>
        <h2 style={{ margin: 0, color: '#0047AB' }}>Settings</h2>
        <div className="tagline">Customize your calm command center</div>
      </div>
    </div>

    <hr />

    {currentUser && (
      <div className="page-card">
        <h3>Current User</h3>
        <div>{currentUser.display_name}</div>
        <div>User #{currentUser.bluprint_id}</div>
        <div>
          Plan: {currentUser.plan_type}
          {currentUser.beta_tester && ' 🧪'}
        </div>
      </div>
    )}

    <hr />

    <div style={{ maxWidth: '500px' }}>

    {/*Time Zone Options*/}
      <div style={{ marginBottom: '18px' }}>
      <label
        style={{
          fontWeight: '600',
          display: 'block',
          marginBottom: '6px'
        }}
      >
        Time Zone
      </label>

      <select
        value={timezone}
        onChange={(e) => setTimezone(e.target.value)}
        style={{ width: '250px' }}
      >
        {TIMEZONE_OPTIONS.map((tz) => (
          <option key={tz.value} value={tz.value}>
            {tz.label}
          </option>
        ))}
      </select>
    </div>

    {/* Operational Day Start */}
    <div style={{ marginBottom: '18px' }}>
      <label
        style={{
          fontWeight: '600',
          display: 'block',
          marginBottom: '6px'
        }}
      >
        What time should BluPrint start a new day?
      </label>

      <select
        value={operationalDayStart}
        onChange={(e) =>
          setOperationalDayStart(
            Number(e.target.value)
          )
        }
        style={{ width: '250px' }}
      >
        {Array.from({ length: 24 }, (_, hour) => {

          const displayHour =
            hour === 0
              ? 12
              : hour > 12
              ? hour - 12
              : hour

          const ampm =
            hour < 12 ? 'AM' : 'PM'

          return (
            <option key={hour} value={hour}>
              {displayHour}:00 {ampm}
            </option>
          )
        })}
      </select>

      <div
        style={{
          fontSize: '0.85rem',
          color: '#666',
          marginTop: '4px'
        }}
      >
        Tasks and recurring schedules will
        roll over at this time.
      </div>
    </div>

    {/*Pause Mode Options*/}
      <div style={{ marginBottom: '18px' }}>
        <label style={{ fontWeight: '600', display: 'block', marginBottom: '6px' }}>
          Pause Mode
        </label>

        <button onClick={() => setPauseMode(!pausedMode)}>
          {pausedMode ? 'On' : 'Off'}
        </button>
      </div>

    {/*Personal Organization Page Direct*/}
        <button
          onClick={() => setPage("personalOrganization")}
        >
          Personal Organization
        </button>

    {/*Default Focus Count Options*/}
      <div style={{ marginBottom: '18px' }}>
        <label style={{ fontWeight: '600', display: 'block', marginBottom: '6px' }}>
          Default Focus Count
        </label>

        <input
          type="number"
          min="1"
          max="10"
          value={focusCount}
          onChange={(e) => setFocusCount(Number(e.target.value))}
          style={{ width: '80px' }}
        />
      </div>

      <div style={{ marginBottom: '18px' }}>
        <label style={{ fontWeight: '600', display: 'block', marginBottom: '6px' }}>
          Default Focus Area
        </label>

        <select
          value={defaultFocusAreaId}
          onChange={(e) => setDefaultFocusAreaId(e.target.value)}
          style={{ width: '300px' }}
        >
          <option value="">-- None --</option>

          {focusAreas.map((area) => (
            <option key={area.id} value={area.id}>
              {area.name}
            </option>
          ))}
        </select>
      </div>

        <div style={{ marginBottom: '18px' }}>
          <label style={{ fontWeight: '600', display: 'block', marginBottom: '6px' }}>
            Default Daily Flow
          </label>

          <select
            value={defaultDailyFlowId}
            onChange={(e) => setDefaultDailyFlowId(e.target.value)}
            style={{ width: '300px' }}
          >
            <option value="">-- None --</option>

            {timeOfDayLevels.map((flow) => (
              <option key={flow.id} value={flow.id}>
                {flow.name}
              </option>
            ))}
          </select>
        </div>

        <div style={{ marginBottom: '18px' }}>
          <label style={{ fontWeight: '600', display: 'block', marginBottom: '6px' }}>
            Default Day Type
          </label>

          <select
            value={defaultDayTypeId}
            onChange={(e) => setDefaultDayTypeId(e.target.value)}
            style={{ width: '300px' }}
          >
            <option value="">-- None --</option>

            {dayTypeLevels.map((dayType) => (
              <option key={dayType.id} value={dayType.id}>
                {dayType.name}
              </option>
            ))}
          </select>
        </div>
        
      <button
        onClick={async () => {
        try {

          await saveUserSettings({
            userId: currentUser.id,
            timezone,
            operationalDayStart,
            focusCount,
            pausedMode,
            defaultFocusAreaId,
            defaultDailyFlowId,
            defaultDayTypeId
          })

          await refreshCurrentUser()

          showToast('Settings saved!')

        } catch (error) {
          console.error(error)
          showToast('Error saving settings.')
        }
      }}
      >
        Save Settings
      </button>

    </div>
  </>
)}

{/* PERSONAL ORGANIZATION PAGE */}
{page === 'personalOrganization' && (
  <PersonalOrganizationPage
    currentUser={currentUser}
  />
)}

{/*ADMIN PAGE*/}
{page === 'admin' && authenticatedUser?.is_admin && (
  <>
    <div className="header">
      <div>
        <h2 style={{ margin: 0, color: '#0047AB' }}>
          Admin Panel
        </h2>
        <div className="tagline">
          Founder tools and account controls
        </div>
      </div>
    </div>

    <hr />

    <div className="stats">
      <div>👥 Total Users: {profiles.length}</div>
      <div>🧪 Beta Testers: {profiles.filter(p => p.beta_tester).length}</div>
      <div>👑 Admins: {profiles.filter(p => p.is_admin).length}</div>
    </div>

    <hr />

{authenticatedUser &&
 authenticatedUser.id !== currentUser?.id &&
 authenticatedUser.is_admin && (

  <button
    onClick={() => {
      switchUser(authenticatedUser)
    }}
    style={{
      marginBottom: '16px'
    }}
  >
    👑 Return to My Account
  </button>

)}

  <button
  onClick={() => setPage('signup')}
  style={{ marginBottom: '16px' }}
>
  + Create Test User
</button>

    <hr />

    <h3>User Accounts</h3>

    {profiles.map(profile => (
      <div
  key={profile.id}
  className="page-card"
  style={{ marginBottom: '12px' }}
>
  <div style={{
    display: 'flex',
    justifyContent: 'space-between',
    gap: '16px',
    flexWrap: 'wrap'
  }}>

    <div style={{ flex: 1 }}>
      <div style={{ fontWeight: 700, fontSize: '20px' }}>
        #{profile.bluprint_id} - {profile.display_name}
      </div>

      <div style={{ color: '#666', marginTop: '4px' }}>
        {profile.plan_type}
        {profile.beta_tester ? ' • 🧪 Beta' : ''}
        {profile.is_admin ? ' • 👑 Admin' : ''}
        {profile.is_active === false ? ' • 🔒 Inactive' : ''}
      </div>

      <div style={{
        marginTop: '10px',
        fontSize: '14px',
        color: '#444'
      }}>
        📋 Tasks: {adminStats[profile.id]?.taskCount || 0}
        {' • '}
        🔁 Recurring: {adminStats[profile.id]?.recurringCount || 0}
        {' • '}
        🌱 Seasons: {adminStats[profile.id]?.seasonCount || 0}
        {' • '}
        📁 Projects: {adminStats[profile.id]?.projectCount || 0}
      </div>
    </div>

    <div style={{
      display: 'flex',
      gap: '8px',
      flexWrap: 'wrap',
      alignItems: 'center'
    }}>
      <button onClick={() => toggleBeta(profile)}>
        {profile.beta_tester ? 'Remove Beta' : 'Make Beta'}
      </button>

      <button onClick={() => toggleActive(profile)}>
        {profile.is_active === false ? 'Activate' : 'Deactivate'}
      </button>

      <button onClick={() => resetUserTasks(profile)}>
        Clear Tasks
      </button>

      <button onClick={() => resetUserRecurring(profile)}>
        Clear Recurring
      </button>

      <button onClick={() => switchUser(profile)}>
        Switch To
      </button>
    </div>
  </div>
</div>
    ))}
  </>
)}

{/*SIGNUP PAGE*/}
{page === 'signup' && (
  <>
    <div className="header">
      <div>
        <h2 style={{ margin: 0, color: '#0047AB' }}>
          Create Your Account
        </h2>
        <div className="tagline">
          Start building your calm command center
        </div>
        <div className="helper-text" style={{ marginTop: '6px' }}>
        * Required fields
      </div>
      </div>
    </div>

    <hr />

    <div className="page-card signup-card">

  <div className="signup-grid three-col">
    <input
      placeholder="First Name *"
      value={signupFirst}
      onChange={(e) => setSignupFirst(e.target.value)}
    />

    <input
      placeholder="Middle"
      value={signupMiddle}
      onChange={(e) => setSignupMiddle(e.target.value)}
    />

    <input
      placeholder="Last Name *"
      value={signupLast}
      onChange={(e) => setSignupLast(e.target.value)}
    />
  </div>

  <div className="signup-grid two-col">
    <input
      placeholder="Display Name *"
      value={signupDisplay}
      onChange={(e) => setSignupDisplay(e.target.value)}
    />

    <input
      placeholder="Email *"
      value={signupEmail}
      onChange={(e) => setSignupEmail(e.target.value)}
    />
  </div>

  <div className="signup-grid two-col">
    <select
      value={signupPlan}
      onChange={(e) => setSignupPlan(e.target.value)}
    >
      <option value="free">Free</option>
      <option value="beta">Beta Tester</option>
      {/*
      <option value="premium">Premium</option>
      <option value="family">Family</option>
      */}
    </select>

    <input
      type="password"
      placeholder="Password *"
      value={signupPassword}
      onChange={(e) => setSignupPassword(e.target.value)}
    />

    <div className="helper-text">
      Plan can be changed later.
    </div>
  </div>

  <button
    className="full-width"
    onClick={handleSignUp}
  >
    Create Account & Start Setup
  </button>

</div>
  </>
)}

    </main>
  </div>
  </div>
)
}

export default App